import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import React__default, { useMemo, memo, useState, useEffect } from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { Alert, Button, Dropdown, Link, List, Util as Util$1, MediaQuery, InfoWindow, QuickFilterButton, toast, Autocomplete, ProductOffers, Breadcrumbs } from '@grandvisionhq/common';
import { Location, Types, OpeningHours, withGetCoordinates, Address, useLocation, LocationSearchMap, LocationDistance, getOpenCloseStatus, getNormalOpenCloseStatusForDay, usePlacePredictions, mapPlacePredictionToSuggestion, LocationSearch } from '@grandvisionhq/locations';
import { useApiClient, Stores } from '@grandvisionhq/api-client';
import { SkeletonLoader, Heading, Text, Button as Button$1, Hr } from '@grandvisionhq/elements';
import { Form, Input, Util } from '@grandvisionhq/forms';
import { withApiConfig, withIntl, useIntl, useFeatureToggles } from '@grandvisionhq/state';
import { findNearestCoordinates, getDistance, formatDistance, slugify, QueryString, parseHtml, DateUtils, DistanceUnit, useSessionStorage, useDebouncedEffect, getDisplayName } from '@grandvisionhq/utils';
import { DataLayer } from '@grandvisionhq/analytics';
import deburr from 'lodash/deburr';
import { gql, useLazyQuery } from '@grandvisionhq/graphql';
import { throttle } from 'throttle-debounce';

const SimpleBreadcrumb = (_param)=>{
    var { className , title , href  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "title",
        "href"
    ]);
    const classes = classnames('store-simple-breadcrumb-stores-v2', className);
    const children = /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "chevron-left"
    }), title);
    return href ? /*#__PURE__*/ React__default.createElement("a", swcHelpers.extends({}, rest, {
        href: href,
        className: classes
    }), children) : /*#__PURE__*/ React__default.createElement("p", swcHelpers.extends({}, rest, {
        className: classes
    }), children);
};

const StoreListItem = (_param)=> {
    var { className , store: { code , shortName , phone , emailAddress , storeNote , openingHours , specialOpeningHours  } , addressData , hidePhone , hideEmail , buttons , onMouseEnter , onMouseLeave , onExpandOpeningHoursCallback  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "store",
        "addressData",
        "hidePhone",
        "hideEmail",
        "buttons",
        "onMouseEnter",
        "onMouseLeave",
        "onExpandOpeningHoursCallback"
    ]);
    return React__default.createElement(Location, swcHelpers.extends({}, rest, {
        className: classnames('store-list-item-stores-v2', className),
        key: code,
        id: code,
        name: shortName,
        variant: Types.LocationVariant.ListItem,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        highlight: false,
        addressData: addressData,
        note: /*#__PURE__*/ React__default.createElement(Alert, {
            type: "info",
            icon: "information-circle",
            message: storeNote
        }),
        openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
            onExpandCallback: onExpandOpeningHoursCallback,
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours
        }),
        buttons: buttons,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }));
};

const StoreListTopContent = (_param)=> {
    var { title , description , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "description",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-list-top-content-stores-v2', className)
    }), title && /*#__PURE__*/ React__default.createElement("h2", {
        className: "h3"
    }, title), description && /*#__PURE__*/ React__default.createElement("p", {
        "data-t": "store-list-top-content-description"
    }, description));
};

const getSvgString = (width, height, theme)=>`<svg width="${width}px" height="${height}px" fill="none" viewBox="0 0 56 66" xmlns="http://www.w3.org/2000/svg"><ellipse cx="28" cy="55.944" rx="7.5158" ry="1.4" fill="${theme.borderColor}" opacity=".4"/><g filter="url(#a)"><path d="m45.537 24.08c0 9.4115-12.706 24.9-16.846 29.343-0.3765 0.4041-1.0051 0.4041-1.3815 0-4.1399-4.4435-16.846-19.932-16.846-29.343 0-10.021 7.8515-17.537 17.537-17.537 9.6854 0 17.537 7.5158 17.537 17.537z" fill="${theme.background}" /><path d="m29.422 54.106c2.1016-2.2557 6.3492-7.2823 10.079-12.94 1.8653-2.8297 3.6145-5.8377 4.9005-8.7507 1.2794-2.8982 2.1352-5.7796 2.1352-8.3344 0-10.586-8.3118-18.537-18.537-18.537-10.225 0-18.537 7.951-18.537 18.537 0 2.5548 0.85581 5.4362 2.1352 8.3344 1.2859 2.913 3.0352 5.921 4.9004 8.7507 3.7295 5.6577 7.9772 10.684 10.079 12.94 0.7719 0.8285 2.073 0.8285 2.8449 0z" stroke="#2B2E31" stroke-width="2"/></g><path d="m34.516 19.027-6.5626 12.578v-5.3908c0-0.3451-0.2798-0.625-0.625-0.625h-5.3907l12.578-6.5625zm0.1691-1.4981c0.3814-0.1978 0.847-0.1257 1.1508 0.1781s0.3759 0.7694 0.1782 1.1509l-8e-4 0.0015-7.4501 14.279c-0.2103 0.4018-0.6679 0.609-1.1085 0.5011-0.4405-0.1079-0.7505-0.5024-0.7513-0.9559v-5.8445h-5.8444c-0.4536-7e-4 -0.8481-0.3108-0.956-0.7513s0.0986-0.8978 0.5005-1.1081l14.28-7.4505 0.0015-7e-4z" clip-rule="evenodd" fill="${theme.borderColor}" fill-rule="evenodd"/><defs><filter id="a" x="1.4629" y=".54364" width="53.073" height="65.183" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="3"/><feGaussianBlur stdDeviation="3.5"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_19113:15839"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_19113:15839" result="shape"/></filter></defs></svg>`
;
const CurrentLocationPin = ({ width: defaultWidth = 56 , height: defaultHeight = 66 , theme  })=>()=>{
        const width = theme.width || defaultWidth;
        const height = theme.height || defaultHeight;
        const anchor = {
            x: Math.round(width / 2),
            y: height
        };
        const size = {
            width,
            height
        };
        const svgString = getSvgString(width, height, theme);
        return {
            url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgString)}`,
            anchor,
            size,
            scaledSize: size
        };
    }
;

const cityRegex = /^([a-zA-Z_\s\-]*)$/;
class PreferredStoreFinder extends React.Component {
    componentDidMount() {
        this.countries = this.getDistinctCountries();
    }
    static getDerivedStateFromProps({ selected , stores  }, prevState) {
        var ref;
        if (!prevState.search && selected && (selected === null || selected === void 0 ? void 0 : selected.code) !== ((ref = prevState.stores.selected) === null || ref === void 0 ? void 0 : ref.code)) {
            // Initialize state from props if user hasn't searched
            return swcHelpers.objectSpread({}, prevState, {
                isNoResults: false,
                location: selected,
                stores: {
                    selected,
                    list: findNearestCoordinates(selected, stores, {
                        limit: 10
                    })
                }
            });
        }
        return null;
    }
    render() {
        var ref;
        const { intl  } = this.props;
        const { search , stores , isNoResults , isTouched  } = this.state;
        const { list  } = stores;
        if (!this.props.stores.length) {
            return /*#__PURE__*/ React.createElement(Alert, {
                type: "error",
                message: intl.getLabel('stores.preferredStore.errorMessage')
            });
        }
        const isValid = this.isPostalCodeOrCity(search) && isTouched;
        const isInvalid = !this.isPostalCodeOrCity(search) && isTouched;
        const inputClasses = classnames('form-control__input', 'preferred-store-finder__input', {
            _is_valid: isValid,
            _is_invalid: isInvalid
        });
        return /*#__PURE__*/ React.createElement("article", {
            className: "preferred-store-finder"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__main"
        }, isNoResults && /*#__PURE__*/ React.createElement(Alert, {
            type: "info",
            message: intl.getLabel('stores.preferredStore.noResults')
        }), /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__search"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "form-control__label"
        }, intl.getLabel('stores.preferredStore.search.label'), /*#__PURE__*/ React.createElement("span", {
            className: "form-control__asterisk"
        }, "*")), /*#__PURE__*/ React.createElement(Form, {
            name: "preferred-store-finder",
            onSubmit: this.handleClickCTA,
            className: "preferred-store-finder__search-form"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__search-form-content"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__input-wrapper"
        }, /*#__PURE__*/ React.createElement(Input, {
            id: "search",
            "data-t": "search",
            className: inputClasses,
            placeholder: intl.getLabel('stores.form.findStore.fields.location.placeholder'),
            onChange: this.handleSearchChange,
            onBlur: this.handleBlur
        }), !this.isPostalCodeOrCity(search) && isTouched && /*#__PURE__*/ React.createElement("span", {
            className: "form-control__error"
        }, intl.getLabel('checkout.address.city.errorMessage'))), /*#__PURE__*/ React.createElement(Button, {
            className: "preferred-store-finder__button",
            color: "secondary",
            type: "submit",
            variant: !search || !this.isPostalCodeOrCity(search) ? 'outline' : 'solid',
            caption: intl.getLabel('stores.preferredStore.cta'),
            onClick: this.handleClickCTA
        })))), list.length > 0 && /*#__PURE__*/ React.createElement("div", {
            className: "preferred-store-finder__result"
        }, /*#__PURE__*/ React.createElement("label", {
            className: "form-control"
        }, /*#__PURE__*/ React.createElement("span", {
            className: "form-control__label"
        }, intl.getLabel('stores.preferredStore.result.label')), /*#__PURE__*/ React.createElement(Dropdown, {
            required: true,
            name: "result",
            handleChange: this.handleStoreSelect,
            options: this.getDropdownOptions(intl.distanceUnit),
            value: (stores === null || stores === void 0 ? void 0 : (ref = stores.selected) === null || ref === void 0 ? void 0 : ref.code) || ''
        })))));
    }
    checkForPostalCode(search) {
        const postCodeRegex = Util.validations.getPostalCodeRegex(this.props.intl.country);
        return (postCodeRegex === null || postCodeRegex === void 0 ? void 0 : postCodeRegex.test(search)) ? `postcode ${search}` : search;
    }
    constructor(...args){
        super(...args);
        this.state = {
            search: '',
            isNoResults: false,
            stores: {
                list: []
            }
        };
        this.countries = [];
        this.getDropdownOptions = (distanceUnit)=>{
            const { location , stores  } = this.state;
            return stores.list.map((item)=>{
                const { town , streetName , streetNumber , code: value  } = item;
                const distance = getDistance(location || {}, item);
                let label = `${town} - ${streetName}`;
                if (streetNumber) {
                    label += ` ${streetNumber}`;
                }
                if (distance !== Infinity) {
                    label += ` (± ${formatDistance(distance, distanceUnit, {
                        precision: 0
                    })})`;
                }
                return {
                    label,
                    value
                };
            });
        };
        this.handleBlur = ()=>{
            if (!this.state.isTouched) {
                this.setState({
                    isTouched: true
                });
            }
        };
        this.handleSearchChange = ({ value: search  })=>this.setState({
                search,
                isNoResults: false
            })
        ;
        this.handleStoreSelect = ({ value  })=>{
            const { onStoreSelect  } = this.props;
            const { list  } = this.state.stores;
            const store = list.find((item)=>item.code === Number(value)
            );
            if (!store) {
                return;
            }
            onStoreSelect(store);
        };
        var _this = this;
        this.handleClickCTA = swcHelpers.asyncToGenerator(function*() {
            const { search  } = _this.state;
            if (!search || !_this.isPostalCodeOrCity(search)) {
                return;
            }
            const result = yield _this.getCoordinatesResult(_this.checkForPostalCode(search));
            if (!result) {
                return _this.setState({
                    isNoResults: true
                });
            }
            const l = result.coordinates;
            const location = {
                lat: l.lat,
                lon: l.lng
            };
            const list = findNearestCoordinates(location, _this.props.stores, {
                limit: 10
            });
            const selected = list[0];
            _this.setState({
                isNoResults: false,
                location,
                stores: {
                    selected,
                    list
                }
            }, ()=>_this.handleStoreSelect({
                    value: selected.code
                })
            );
        });
        this.getDistinctCountries = ()=>{
            const { stores  } = this.props;
            const result = [];
            stores.forEach(({ country  })=>!result.includes(country) && result.push(country)
            );
            return result;
        };
        var _this1 = this;
        this.getCoordinatesResult = function() {
            var _ref = swcHelpers.asyncToGenerator(function*(input) {
                const { apiConfig , getCoordinates  } = _this1.props;
                try {
                    return yield getCoordinates(apiConfig.locationsUrl, {
                        query: input
                    });
                } catch (e) {
                    console.error(e);
                }
            });
            return function(input) {
                return _ref.apply(this, arguments);
            };
        }();
        this.validateCity = (v)=>v.trim() ? cityRegex.test(v) : false
        ;
        this.isPostalCodeOrCity = (v)=>{
            return [
                Util.validations.getPostalCodeRegex(this.props.intl.country),
                this.validateCity
            ].some((validator)=>{
                return validator instanceof Function ? validator(v) : validator === null || validator === void 0 ? void 0 : validator.test(v);
            });
        };
    }
}
const PreferredStoreFinderLoader = ()=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(SkeletonLoader, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "80px",
        "aria-label": getLabel('common.loadingText')
    }, /*#__PURE__*/ React.createElement("rect", {
        width: "80%",
        height: "32px",
        rx: "4",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("rect", {
        width: "50%",
        height: "32px",
        rx: "4",
        fill: "currentColor",
        y: "48"
    })));
};
const WithStores = (_param)=>{
    var { apiConfig  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "apiConfig"
    ]);
    const [isLoading, stores, error] = useApiClient(Stores.list, null, apiConfig.storesUrl);
    if (error) {
        throw error;
    }
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(PreferredStoreFinderLoader, null);
    }
    return /*#__PURE__*/ React.createElement(PreferredStoreFinder, swcHelpers.extends({
        stores: stores || [],
        apiConfig: apiConfig
    }, rest));
};
WithStores.displayName = 'WithStores(PreferredStoreFinder)';
var PreferredStoreFinder$1 = withGetCoordinates(withApiConfig(withIntl(WithStores)));

const StoreFinderItem = (_param)=> {
    var { className , variant , title , addressData , addressSize , children , onClick , onMouseEnter , onMouseLeave  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "variant",
        "title",
        "addressData",
        "addressSize",
        "children",
        "onClick",
        "onMouseEnter",
        "onMouseLeave"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('stores-v2-store-finder-item', className, {
            'stores-v2-store-finder-item--list-item': variant === 'list-item',
            'stores-v2-store-finder-item--map-item': variant === 'map-item'
        }),
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
    }), /*#__PURE__*/ React.createElement("span", {
        className: "stores-v2-store-finder-item__details"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "stores-v2-store-finder-item__title"
    }, title), /*#__PURE__*/ React.createElement(Address, {
        className: "stores-v2-store-finder-item__address",
        data: addressData,
        size: addressSize
    }), children), variant === 'map-item' && /*#__PURE__*/ React.createElement("span", {
        className: "stores-v2-store-finder-item__chevron"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    })));
};

const Star = ({ className , fill  })=>/*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-star', {
            'store-rating-star--empty': fill < 0.5,
            'store-rating-star--half': fill === 0.5,
            'store-rating-star--full': fill > 0.5
        }, className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__foreground"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__foreground-container"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: 32,
        height: 32
    }))), /*#__PURE__*/ React.createElement("div", {
        className: "store-rating-star__background"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "star",
        width: 32,
        height: 32
    })))
;

const Stars = ({ className , rating: rating1 , count =5  })=>{
    const getFill = (index, rating)=>{
        const ratingMinusOffset = Math.max(0, rating - index);
        const fill = Math.min(1, Math.round(ratingMinusOffset * 10 / (0.5 * 10)) * 0.5);
        return fill;
    };
    const array = React.useMemo(()=>Array.from({
            length: count
        })
    , [
        count
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('store-rating-stars', className)
    }, array.map((_entry, index)=>/*#__PURE__*/ React.createElement(Star, {
            key: `star-${index}`,
            fill: getFill(index, rating1)
        })
    ));
};

var StoreRating = (_param)=>{
    var { className , labels , rating , urls , onClickReview  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "rating",
        "urls",
        "onClickReview"
    ]);
     return React.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-rating', className)
    }), /*#__PURE__*/ React.createElement(Heading, {
        className: "store-rating__title",
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement(Stars, {
        className: "store-rating__stars",
        rating: rating,
        "aria-hidden": true
    }), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating",
        variant: "body"
    }, labels.rating), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__rating-count",
        variant: "body"
    }, labels.ratingCount), /*#__PURE__*/ React.createElement(Text, {
        className: "store-rating__description",
        variant: "body"
    }, labels.description), (urls === null || urls === void 0 ? void 0 : urls.review) && /*#__PURE__*/ React.createElement(Link, {
        className: "store-rating__review",
        url: urls.review,
        target: "_blank",
        onClick: onClickReview
    }, labels.review));
};

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  SimpleBreadcrumb: SimpleBreadcrumb,
  StoreListItem: StoreListItem,
  StoreListTopContent: StoreListTopContent,
  CurrentLocationPin: CurrentLocationPin,
  PreferredStoreFinder: PreferredStoreFinder$1,
  StoreFinderItem: StoreFinderItem,
  StoreRating: StoreRating
});

const StoreContactInfo = (_param)=> {
    var { name , addressSize , addressData , emailAddress , phone  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "name",
        "addressSize",
        "addressData",
        "emailAddress",
        "phone"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: "store-contact-info-stores-v2"
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small",
        component: "h2",
        className: "store-contact-info-stores-v2__title"
    }, name), /*#__PURE__*/ React__default.createElement(Address, {
        className: "store-contact-info-stores-v2__info",
        size: addressSize,
        data: addressData
    }, phone && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-contact-info-stores-v2__info-item"
    }, /*#__PURE__*/ React__default.createElement("a", {
        href: `tel:${phone}`,
        "data-t": "Phone"
    }, phone)), emailAddress && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-contact-info-stores-v2__info-item"
    }, /*#__PURE__*/ React__default.createElement("a", {
        href: `mailto:${emailAddress}`,
        "data-t": "Email"
    }, emailAddress))));
};

const StoreContactInfoContainer = (_param)=>{
    var { store , hidePhone , hideEmail  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "hidePhone",
        "hideEmail"
    ]);
    var _additionalStreetInfo;
    const addressData = React__default.useMemo(()=>({
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            additionalStreetInfo: (_additionalStreetInfo = store.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : '',
            postalCode: store.postalCode,
            town: store.town
        })
    , [
        store
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreContactInfo, swcHelpers.extends({}, rest, {
        name: store.name,
        addressSize: "COMPLETE",
        addressData: addressData,
        phone: hidePhone ? undefined : store.phone,
        emailAddress: hideEmail ? undefined : store.emailAddress
    }));
};

var _postalCode;
const storeDetailsEvent = ({ interaction , store  })=>({
        event: 'storeDetailsClick',
        storeLocator: {
            action: {
                step: 'store locator details',
                interaction
            },
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode = store.postalCode) !== null && _postalCode !== void 0 ? _postalCode : ''
            }
        }
    })
;
var _postalCode1;
const storeGroupEvent = ({ interaction , store , step , city  })=>({
        event: 'storeGroupClick',
        storeLocator: swcHelpers.objectSpread({
            action: swcHelpers.objectSpread({
                step,
                interaction
            }, city === undefined ? {} : {
                city
            })
        }, store === undefined ? {} : {
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode1 = store.postalCode) !== null && _postalCode1 !== void 0 ? _postalCode1 : ''
            }
        })
    })
;
var _postalCode2;
const storesLocatorResultEvent = ({ interaction , searchResults , searchPosition , store ,  })=>({
        event: 'storeSearchResults',
        storeLocator: {
            action: swcHelpers.objectSpread({
                step: 'store locator results',
                interaction
            }, searchResults === undefined ? {} : {
                searchResults
            }, searchPosition === undefined ? {} : {
                searchPosition
            }),
            store: {
                id: String(store.code),
                name: store.name,
                city: store.town,
                country: store.country,
                address: `${store.streetName}${store.streetNumber ? ` ${store.streetNumber}` : ''}${store.additionalStreetInfo ? ` ${store.additionalStreetInfo}` : ''}, ${store.town}`,
                postalCode: (_postalCode2 = store.postalCode) !== null && _postalCode2 !== void 0 ? _postalCode2 : ''
            }
        }
    })
;
const storeSearchSubmitEvent = ({ interaction , searchResults , location ,  })=>({
        event: 'storeSearchSubmit',
        storeLocator: {
            action: {
                step: 'store locator search',
                interaction,
                location,
                searchResults
            }
        }
    })
;
const storesSearchFilterEvent = ({ activeFilters , searchResults  })=>({
        event: 'storeSearchFilter',
        storeLocator: {
            action: {
                step: 'store filter',
                interaction: 'filter click',
                filterName: activeFilters.join(', '),
                searchResults: searchResults !== null && searchResults !== void 0 ? searchResults : null
            }
        }
    })
;

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  storeDetailsEvent: storeDetailsEvent,
  storeGroupEvent: storeGroupEvent,
  storesLocatorResultEvent: storesLocatorResultEvent,
  storeSearchSubmitEvent: storeSearchSubmitEvent,
  storesSearchFilterEvent: storesSearchFilterEvent
});

const createBreadcrumbs = (store, rootLabel, storesRoute)=>{
    if (!storesRoute) {
        console.error('createBreadcrumbs: Could not create breadcrumbs because storesRoute was not found');
        return [];
    }
    return [
        {
            name: 'Home',
            url: '/'
        },
        {
            name: rootLabel,
            url: storesRoute
        },
        {
            name: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbName : store.town,
            url: store.breadcrumbName && store.breadcrumbSlug ? store.breadcrumbSlug : `${storesRoute}?search=${store.town}`
        },
        {
            name: `${store.name}`,
            url: `${storesRoute}/${store.slug}`
        }, 
    ];
};
const getBookAppointmentUrl = (bookAppointmentUrl, options)=>{
    return (store)=>{
        var ref, ref1;
        const { code  } = store;
        let result = bookAppointmentUrl;
        if ((options === null || options === void 0 ? void 0 : (ref = options.alternativeUrl) === null || ref === void 0 ? void 0 : ref.length) && (options === null || options === void 0 ? void 0 : (ref1 = options.alternativeUrlStores) === null || ref1 === void 0 ? void 0 : ref1.includes(code))) {
            result = options.alternativeUrl;
        }
        if (options === null || options === void 0 ? void 0 : options.paddedLength) {
            const storeId = String(code).padStart(options.paddedLength, '0');
            result = `${result}?storeId=${storeId}`;
        } else {
            result = `${result}?storeId=${code}`;
        }
        return result;
    };
};
var _slug;
const getStoreDetailUrl = (storesListUrl)=>(store)=>`${storesListUrl}/${slugify(store.town)}/${(_slug = store.slug) !== null && _slug !== void 0 ? _slug : store.code}`
;
const areServicesAvailable = (store, services)=>{
    var ref;
    return !(store === null || store === void 0 ? void 0 : (ref = store.servicesNotAvailable) === null || ref === void 0 ? void 0 : ref.some((notAvailable)=>services.includes(notAvailable)
    ));
};
const isEqualStores = (a, b)=>{
    if (a === b) {
        return true;
    }
    if (a.length !== b.length) {
        return false;
    }
    const codes = a.map(({ code  })=>code
    );
    for (const store of b){
        const index = codes.indexOf(store.code);
        if (index === -1) {
            return false;
        }
        codes.splice(index, 1);
    }
    return true;
};
const removeEmptyValues = (queryParams)=>Object.entries(queryParams).filter(([, value])=>value !== null && value !== undefined && value !== ''
    ).reduce((acc, [key, value])=>swcHelpers.objectSpread({}, acc, {
            [key]: value
        })
    , {})
;
var getStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    const queryParams = QueryString.parse(window.location.search.substring(1));
    /** Remove old search and userLocation parameters before setting newQueryParams */ const restQueryParams = swcHelpers.objectWithoutProperties(queryParams, [
        "userLocation",
        "search"
    ]);
    /** Remove empty parameters to avoid having ?something=true&search= in url */ const params = swcHelpers.objectSpread({}, removeEmptyValues(restQueryParams), removeEmptyValues(newQueryParams));
    const isEmptyParams = Object.keys(params).length === 0;
    return `${window.location.pathname}${QueryString.stringify(params, isEmptyParams)}`;
};
const replaceStoreFinderUrlWithNewQueryParams = (newQueryParams)=>{
    window.history.replaceState(null, 'store-finder', getStoreFinderUrlWithNewQueryParams(newQueryParams));
};

const getAddressFromSuggestions = (suggestions, id)=>{
    const suggestion1 = suggestions.find((suggestion)=>suggestion.id === id
    );
    const { title ='' , subTitle  } = suggestion1 !== null && suggestion1 !== void 0 ? suggestion1 : {};
    return `${title}${subTitle ? ', ' + subTitle : ''}`;
};

const defaultSearchWhitelist = [
    'postalCode',
    'streetName',
    'town'
];
const normalize = (value)=>typeof value === 'string' || typeof value === 'number' ? deburr(value.toString()).toLowerCase() : ''
;
const searchStore = (store, query, searchWhitelist = defaultSearchWhitelist)=>{
    const normalizedQuery = normalize(query);
    return searchWhitelist.some((key)=>normalize(store[key]).includes(normalizedQuery)
    );
};

const getActiveCampaignBanner = (banner, { storeCode  })=>{
    if (!banner) return;
    if (!(banner === null || banner === void 0 ? void 0 : banner.startDate) || !(banner === null || banner === void 0 ? void 0 : banner.endDate)) return;
    if (!(Date.now() > banner.startDate && Date.now() < banner.endDate)) return;
    // if there is no store specified we need to show the banner on all stores
    if (!banner.storesList) {
        return {
            url: banner.url,
            description: banner.description
        };
    }
    const list = banner.storesList.split(',');
    const storeNumberList = list.map((item)=>{
        const res = Number(item);
        if (isNaN(res)) return;
        return res;
    });
    const found = storeNumberList === null || storeNumberList === void 0 ? void 0 : storeNumberList.find((item)=>item === storeCode
    );
    if (found !== storeCode) return;
    return {
        url: banner.url,
        description: banner.description
    };
};

const getActiveStoreOffers = (availableProductCategories = [], storeProductCategories)=>{
    const enabledPerStore = storeProductCategories === null || storeProductCategories === void 0 ? void 0 : storeProductCategories.map(({ code  })=>code
    );
    return availableProductCategories.filter(({ key  })=>{
        return enabledPerStore === null || enabledPerStore === void 0 ? void 0 : enabledPerStore.includes(key);
    }).map(({ title , description , image , link  })=>{
        return {
            title,
            description,
            url: link,
            imageUrl: image === null || image === void 0 ? void 0 : image.url
        };
    });
};

var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createBreadcrumbs: createBreadcrumbs,
  getBookAppointmentUrl: getBookAppointmentUrl,
  getStoreDetailUrl: getStoreDetailUrl,
  areServicesAvailable: areServicesAvailable,
  isEqualStores: isEqualStores,
  removeEmptyValues: removeEmptyValues,
  getStoreFinderUrlWithNewQueryParams: getStoreFinderUrlWithNewQueryParams,
  replaceStoreFinderUrlWithNewQueryParams: replaceStoreFinderUrlWithNewQueryParams,
  getAddressFromSuggestions: getAddressFromSuggestions,
  searchStore: searchStore,
  getActiveCampaignBanner: getActiveCampaignBanner,
  getActiveStoreOffers: getActiveStoreOffers
});

const StoreBookAppointmentCTA = (_param)=> {
    var { className , labels , onClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "onClick"
    ]);
    return React__default.createElement(Button$1, swcHelpers.extends({}, rest, {
        className: classnames('store-book-appointment-cta-stores-v2', className),
        variant: "solid",
        onClick: onClick
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "store-book-appointment-cta-stores-v2__icon"
    }, /*#__PURE__*/ React__default.createElement(Icon, {
        name: "calendar"
    })), labels.caption);
};

const StoreBookAppointmentCTAContainer = (_param)=>{
    var { url , code , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , storeCode , appointmentTypeId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "url",
        "code",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "storeCode",
        "appointmentTypeId"
    ]);
    const { featureConfigs  } = useFeatureToggles();
    const { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } = featureConfigs;
    const location = getBookAppointmentUrl(url, {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })({
        code
    });
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            caption: getLabel('stores.page.details.action.bookAppointment')
        })
    , [
        getLabel
    ]);
    const onClick = React__default.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'book appointment click',
            store: {
                code,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
        window.location.assign(location);
    }, [
        location,
        code,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBookAppointmentCTA, swcHelpers.extends({}, rest, {
        labels: labels,
        onClick: onClick
    }));
};

const StoreFacilities = (_param)=>{
    var { className , labels , facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "facilities"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-facilities-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React__default.createElement(List, {
        items: facilities,
        icon: "checkmark"
    }));
};

const StoreFacilitiesContainer = (_param)=>{
    var { facilities  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "facilities"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.facilities.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreFacilities, swcHelpers.extends({
        labels: labels,
        facilities: facilities
    }, rest));
};

const storeFinderContextDefaultValues = {
    config: {
        googleMapsId: '',
        hidePhone: false,
        hideEmail: false,
        withUrlParams: false,
        storeFilter: ()=>true
    },
    stores: [],
    hoveredStore: null,
    isStoresLoading: false,
    isLocationSelected: false,
    searchQuery: '',
    suggestions: [],
    isPristineSearch: false,
    isUsingUserLocation: false,
    useUserLocationError: null,
    isUserLocationLoading: false,
    isUserLocationRequested: false,
    setIsUserLocationRequested: ()=>null
    ,
    clearSearch: ()=>null
    ,
    setSelectedLocation: ()=>null
    ,
    setSuggestions: ()=>null
    ,
    setIsPristineSearch: ()=>null
    ,
    setStores: ()=>null
    ,
    setHoveredStore: ()=>null
    ,
    setSearchQuery: ()=>null
    ,
    setIsStoresLoading: ()=>null
};
const StoreFinderContext = /*#__PURE__*/ React__default.createContext(storeFinderContextDefaultValues);
const useStoreFinderContext = ()=>{
    const context = React__default.useContext(StoreFinderContext);
    if (context === storeFinderContextDefaultValues) {
        throw new Error('No StoreFinderContext available. You might still need to wrap the application with the StoreFinderProvider component.');
    }
    return context;
};
StoreFinderContext.displayName = 'StoreFinder';
const StoreFinderConsumer = StoreFinderContext.Consumer;

const StoreFinderProvider = ({ children , googleMapsId , hidePhone =false , hideEmail =false , withUrlParams =false , storeFilter =()=>true
 ,  })=>{
    const [stores, setStores] = React__default.useState([]);
    const [hoveredStore, setHoveredStore] = React__default.useState(null);
    const [isStoresLoading, setIsStoresLoading] = React__default.useState(false);
    const [searchQuery, setSearchQuery] = React__default.useState('');
    const [isPristineSearch, setIsPristineSearch] = React__default.useState(true);
    const [suggestions, setSuggestions] = React__default.useState([]);
    const [selectedLocation, setSelectedLocation] = React__default.useState('');
    const { position: userLocation , isPositionLoading: isUserLocationLoading , isUseMyLocation: isUsingUserLocation , isMyLocationRequested: isUserLocationRequested , setIsMyLocationRequested: setIsUserLocationRequested , error: useUserLocationError ,  } = useLocation(false, {
        enableHighAccuracy: true,
        timeout: 10 * 1000,
        maximumAge: 0
    });
    const clearSearch = React__default.useCallback(()=>{
        setSearchQuery('');
        setSelectedLocation('');
        setSuggestions([]);
        setIsUserLocationRequested(false);
    }, [
        setSearchQuery,
        setSelectedLocation,
        setSuggestions,
        setIsUserLocationRequested
    ]);
    const config = React__default.useMemo(()=>({
            googleMapsId,
            hidePhone,
            hideEmail,
            withUrlParams,
            storeFilter
        })
    , [
        googleMapsId,
        hidePhone,
        hideEmail,
        withUrlParams,
        storeFilter
    ]);
    const values = React__default.useMemo(()=>({
            config,
            stores,
            hoveredStore,
            isLocationSelected: selectedLocation.length > 0,
            searchQuery: selectedLocation.length > 0 ? selectedLocation : searchQuery,
            isStoresLoading,
            isPristineSearch,
            suggestions,
            userLocation,
            isUsingUserLocation,
            useUserLocationError,
            isUserLocationRequested,
            setIsUserLocationRequested,
            isUserLocationLoading,
            clearSearch,
            setSelectedLocation,
            setSuggestions,
            setIsPristineSearch,
            setSearchQuery,
            setStores,
            setHoveredStore,
            setIsStoresLoading
        })
    , [
        config,
        stores,
        hoveredStore,
        searchQuery,
        isStoresLoading,
        isPristineSearch,
        suggestions,
        selectedLocation,
        userLocation,
        isUsingUserLocation,
        useUserLocationError,
        isUserLocationRequested,
        setIsUserLocationRequested,
        isUserLocationLoading,
        setSelectedLocation,
        setSuggestions,
        setIsPristineSearch,
        setStores,
        setHoveredStore,
        setSearchQuery,
        setIsStoresLoading,
        clearSearch, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreFinderContext.Provider, {
        value: values
    }, children);
};

const StoreInfoWindow = ({ className , code , name , shortName , addressData , email , phone , hideEmail , hidePhone , openingHours , specialOpeningHours , buttons , note ,  })=>/*#__PURE__*/ React__default.createElement(Location, {
        className: classnames('store-info-window', className),
        id: code,
        name: shortName !== null && shortName !== void 0 ? shortName : name,
        addressData: addressData,
        emailAddress: email,
        emailHidden: hideEmail,
        phone: phone,
        phoneHidden: hidePhone,
        note: note,
        openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours,
            isExpandable: false
        }),
        buttons: buttons,
        variant: Types.LocationVariant.MapItem
    })
;

const StoreInfoWindowContainer = (_param)=>{
    var { store , buttonsComponent: ButtonsComponent , closeInfoWindow  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "buttonsComponent",
        "closeInfoWindow"
    ]);
    const { config  } = useStoreFinderContext();
    const { hidePhone , hideEmail  } = config;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , emailAddress , storeNote ,  } = store;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreInfoWindow, swcHelpers.extends({}, store, rest, {
        note: /*#__PURE__*/ React__default.createElement(Alert, {
            type: "info",
            icon: "information-circle",
            message: storeNote
        }),
        email: emailAddress || '',
        addressData: addressData,
        hideEmail: hideEmail,
        hidePhone: hidePhone,
        buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
            store: store,
            view: "map",
            closeInfoWindow: closeInfoWindow
        }) : undefined
    }));
};

const currentLocationPin = CurrentLocationPin({
    theme: {
        borderColor: '#2B2E31',
        background: '#fff'
    }
});
function StoreFinderMapContainer({ stores , infoWindowContentComponent: InfoWindowContentComponent , buttonsComponent: ButtonsComponent  }) {
    const { hoveredStore: hoveredStoreInList , config , isUsingUserLocation , userLocation , isUserLocationRequested , setIsUserLocationRequested ,  } = useStoreFinderContext();
    const { getLabel  } = useIntl();
    const { googleMapsId , hideEmail , hidePhone  } = config;
    const [activeInfoWindow, setActiveInfoWindow] = React__default.useState(null);
    const [activeStore, setActiveStore] = React__default.useState(null);
    const prevStores = Util$1.usePrevious(stores);
    const [hoveredStore, setHoveredStore] = React__default.useState(null);
    const isPhone = MediaQuery.useIsPhone();
    const handleOnClickUseMyLocation = React__default.useCallback(()=>{
        if (!isUserLocationRequested) {
            setIsUserLocationRequested(true);
        }
    }, [
        isUserLocationRequested,
        setIsUserLocationRequested
    ]);
    const handleOnMarkerClick = React__default.useCallback((code)=>{
        if (activeInfoWindow === code) {
            setActiveInfoWindow(null);
            setActiveStore(null);
            return;
        }
        const store1 = stores.find((store)=>store.code === code
        );
        if (store1) {
            const dataLayerEvent = storesLocatorResultEvent({
                store: store1,
                interaction: 'map click - marker',
                searchResults: stores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
            setActiveInfoWindow(code);
            setActiveStore(store1);
        }
    }, [
        activeInfoWindow,
        stores
    ]);
    const handleOnMarkerHover = React__default.useCallback((code)=>{
        setHoveredStore(code);
    }, []);
    const closeInfoWindow = React__default.useCallback(()=>{
        setActiveInfoWindow(null);
        setActiveStore(null);
    }, []);
    const markers = React__default.useMemo(()=>{
        const storeMarkers = stores.map((store)=>{
            const { code , lat , lon  } = store;
            const Component = InfoWindowContentComponent !== null && InfoWindowContentComponent !== void 0 ? InfoWindowContentComponent : StoreInfoWindowContainer;
            return {
                code,
                title: getLabel('stores.component.storeFinderMap.map.pin.title'),
                optimized: false,
                position: {
                    lat: Number(lat),
                    lng: Number(lon)
                },
                infoWindow: activeInfoWindow === code && !isPhone && /*#__PURE__*/ React__default.createElement(InfoWindow, {
                    position: {
                        lat: Number(lat),
                        lng: Number(lon)
                    },
                    options: {
                        pixelOffset: {
                            width: 0,
                            height: -45
                        }
                    },
                    onCloseClick: closeInfoWindow
                }, /*#__PURE__*/ React__default.createElement(Component, {
                    className: "store-finder-map__info-window-contents",
                    store: store,
                    buttonsComponent: ButtonsComponent,
                    closeInfoWindow: closeInfoWindow
                }))
            };
        });
        const userMarker = isUsingUserLocation && userLocation ? [
            {
                position: {
                    lat: userLocation.lat,
                    lng: userLocation.lng
                },
                pin: currentLocationPin
            }, 
        ] : [];
        return [
            ...storeMarkers,
            ...userMarker
        ];
    }, [
        getLabel,
        stores,
        activeInfoWindow,
        InfoWindowContentComponent,
        ButtonsComponent,
        isUsingUserLocation,
        closeInfoWindow,
        userLocation,
        isPhone, 
    ]);
    const center = React__default.useMemo(()=>{
        if (isUsingUserLocation && userLocation !== undefined) {
            return userLocation;
        }
        return undefined;
    }, [
        userLocation,
        isUsingUserLocation
    ]);
    React__default.useEffect(()=>{
        if (prevStores && !isEqualStores(prevStores, stores)) {
            setActiveStore(null);
            setActiveInfoWindow(null);
        }
    }, [
        stores,
        prevStores
    ]);
    var ref;
    return /*#__PURE__*/ React__default.createElement(LocationSearchMap, {
        id: googleMapsId,
        markers: markers,
        markersUpdateConfig: {
            centerToFirst: true,
            zoom: 13
        },
        center: center,
        highlight: (ref = activeStore === null || activeStore === void 0 ? void 0 : activeStore.code) !== null && ref !== void 0 ? ref : null,
        hovered: hoveredStore !== null && hoveredStore !== void 0 ? hoveredStore : hoveredStoreInList === null || hoveredStoreInList === void 0 ? void 0 : hoveredStoreInList.code,
        userLocation: isUsingUserLocation && userLocation ? userLocation : undefined,
        userLocationZoomLevel: 13,
        centerOnUserLocation: true,
        activeLocation: isPhone && activeStore ? /*#__PURE__*/ React__default.createElement("div", {
            className: "store-finder-map__active-location"
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: "store-finder-map__active-location-close-button",
            "data-t": "close-button"
        }, /*#__PURE__*/ React__default.createElement("button", {
            onClick: closeInfoWindow
        }, /*#__PURE__*/ React__default.createElement(Icon, {
            name: "close"
        }))), InfoWindowContentComponent ? /*#__PURE__*/ React__default.createElement(InfoWindowContentComponent, {
            className: "store-finder-map__active-location-contents",
            store: activeStore,
            buttonsComponent: ButtonsComponent,
            closeInfoWindow: closeInfoWindow
        }) : /*#__PURE__*/ React__default.createElement(Location, {
            className: "store-finder-map__active-location-contents",
            id: activeStore.code,
            name: activeStore.name,
            addressData: {
                additionalStreetInfo: activeStore.additionalStreetInfo,
                streetName: activeStore.streetName,
                streetNumber: activeStore.streetNumber,
                postalCode: activeStore.postalCode,
                town: activeStore.town,
                province: activeStore.province
            },
            emailAddress: activeStore.emailAddress,
            emailHidden: hideEmail,
            phone: activeStore.phone,
            phoneHidden: hidePhone,
            note: /*#__PURE__*/ React__default.createElement(Alert, {
                type: "info",
                icon: "information-circle",
                message: activeStore.storeNote
            }),
            openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
                openingHours: activeStore.openingHours,
                specialOpeningHours: activeStore.specialOpeningHours,
                isExpandable: false
            }),
            buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
                store: activeStore,
                view: "map",
                closeInfoWindow: closeInfoWindow
            }) : undefined,
            variant: Types.LocationVariant.MapItem
        })) : null,
        onClickUseMyLocation: handleOnClickUseMyLocation,
        onMarkerClick: handleOnMarkerClick,
        onMarkerHover: handleOnMarkerHover,
        onMapClick: closeInfoWindow
    });
}

const StoreDetailImage = (_param)=> {
    var { className , storeDetailImage , isFallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "storeDetailImage",
        "isFallbackImage"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames(className, 'store-detail-image-stores-v2', {
            'store-detail-image-stores-v2--fallback': isFallbackImage
        })
    }), /*#__PURE__*/ React__default.createElement("img", {
        className: "store-detail-image-stores-v2__image",
        "data-t": "StoreDetailImage",
        alt: "Store",
        src: storeDetailImage
    }));
};

const StoreDetailImageContainer = (_param)=>{
    var { detailImage , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "detailImage",
        "fallbackImage"
    ]);
    const storeDetailImage = detailImage || fallbackImage;
    if (!storeDetailImage) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(StoreDetailImage, swcHelpers.extends({}, rest, {
        storeDetailImage: storeDetailImage,
        isFallbackImage: !detailImage
    }));
};

const StoreDescription = (_param)=>{
    var { className , labels , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "description"
    ]);
    return description ? /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-description', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), parseHtml(description)) : null;
};

const StoreDescriptionContainer = (_param)=>{
    var { storeName , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeName",
        "description"
    ]);
    const { getFormattedLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getFormattedLabel('stores.page.details.description.title', {
                labelData: {
                    store: storeName
                }
            })
        })
    , [
        storeName,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreDescription, swcHelpers.extends({
        labels: labels,
        description: description
    }, rest));
};

const formatDistanceQueryData = (data, options)=>{
    let { distanceUnit  } = options;
    const { locale  } = options;
    const { distance , timeByCar , timeByFoot  } = data;
    if (distance && distance < 1000) {
        if (distanceUnit === DistanceUnit.meter || distanceUnit === DistanceUnit.km) {
            distanceUnit = DistanceUnit.meter;
        }
    }
    // format the values when they are are not null or undefined
    return {
        distance: distance != undefined ? formatDistance(distance, distanceUnit, {
            separator: ' '
        }) : distance,
        timeByCar: timeByCar != undefined ? DateUtils.minutesToHM(timeByCar, locale) : timeByCar,
        timeByFoot: timeByFoot != undefined ? DateUtils.minutesToHM(timeByFoot, locale) : timeByFoot
    };
};

const storeDistance = gql`
  fragment StoreDistance on Store {
    distance @include(if: $withDistance)
    timeByCar @include(if: $withTimeByCar)
    timeByFoot @include(if: $withTimeByFoot)
  }
`;
const GET_STORE_DISTANCE = gql`
  query GetStoreDistance(
    $code: Int!
    $deviceGeoLocation: GeoLocationInput!
    $withDistance: Boolean = false
    $withTimeByCar: Boolean = false
    $withTimeByFoot: Boolean = false
  ) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation) {
      ...StoreDistance
    }
  }
  ${storeDistance}
`;

const useStoreDistance = ()=>{
    const [getStoreDistance, { error , loading , data  }] = useLazyQuery(GET_STORE_DISTANCE);
    // @TODO investigate DistanceInMeters type and remove the StoreDistance type cast
    const { distance , timeByCar , timeByFoot  } = (data === null || data === void 0 ? void 0 : data.store) || {};
    return useMemo(()=>[
            getStoreDistance,
            {
                // set a clean attributes list if data is defined and undefined if data is undefined
                data: data ? {
                    distance,
                    timeByCar,
                    timeByFoot
                } : data,
                loading,
                error
            }, 
        ]
    , [
        data,
        distance,
        timeByCar,
        timeByFoot,
        loading,
        error,
        getStoreDistance
    ]);
};

function StoreDistanceContainer({ className , code  }) {
    const { distanceUnit , locale  } = useIntl();
    const [hasPermissions, setHasPermissions] = useState(false);
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const { position: deviceLocation , setIsMyLocationRequested  } = useLocation(false, {
        enableHighAccuracy: true,
        maximumAge: 1000
    });
    const [getStoreDistance, { data  }] = useStoreDistance();
    const distanceProps = useMemo(()=>data ? formatDistanceQueryData(data, {
            distanceUnit,
            locale
        }) : {}
    , [
        data,
        distanceUnit,
        locale
    ]);
    useEffect(()=>{
        if (deviceLocation) {
            getStoreDistance({
                variables: {
                    code,
                    deviceGeoLocation: {
                        lat: deviceLocation.lat,
                        lon: deviceLocation.lng
                    },
                    withDistance: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.distance,
                    withTimeByCar: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByCar,
                    withTimeByFoot: storeDistanceConfig === null || storeDistanceConfig === void 0 ? void 0 : storeDistanceConfig.timeByFoot
                }
            });
        }
    }, [
        code,
        deviceLocation,
        storeDistanceConfig,
        getStoreDistance
    ]);
    useEffect(()=>{
        if (hasPermissions) {
            setIsMyLocationRequested(true);
        } else {
            setIsMyLocationRequested(false);
        }
    }, [
        hasPermissions,
        setIsMyLocationRequested
    ]);
    useEffect(()=>{
        let unsubscribe;
        if ('permissions' in navigator) {
            navigator.permissions.query({
                name: 'geolocation'
            }).then((permissionStatus)=>{
                setHasPermissions(permissionStatus.state === 'granted');
                const handler = ()=>{
                    setHasPermissions(permissionStatus.state === 'granted');
                };
                permissionStatus.addEventListener('change', handler);
                unsubscribe = ()=>permissionStatus.removeEventListener('change', handler)
                ;
            });
        }
        return unsubscribe;
    }, []);
    return /*#__PURE__*/ React__default.createElement(LocationDistance, swcHelpers.extends({
        className: className
    }, distanceProps));
}
var StoreDistance = /*#__PURE__*/ memo(StoreDistanceContainer);

const StoreLocation = (_param)=> {
    var { className , labels , addressSize , addressData , mapImageUrl , directionsUrl , distanceDetails =null , practicalInformation , onGetDirectionsClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "addressSize",
        "addressData",
        "mapImageUrl",
        "directionsUrl",
        "distanceDetails",
        "practicalInformation",
        "onGetDirectionsClick"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-location-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React__default.createElement("img", {
        className: "store-location-stores-v2__map",
        src: mapImageUrl,
        alt: labels.title,
        "data-t": "StaticMapImage"
    }), addressData && /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.address), /*#__PURE__*/ React__default.createElement(Address, {
        size: addressSize,
        data: addressData
    }), distanceDetails && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__distance-details"
    }, distanceDetails), practicalInformation && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__practical-information"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.practicalInformationTitle), /*#__PURE__*/ React__default.createElement("p", null, practicalInformation)), /*#__PURE__*/ React__default.createElement(Button, {
        className: "store-location-stores-v2__get-directions-button",
        hrefTarget: "_blank",
        icon: "location-pin",
        href: directionsUrl,
        onClick: onGetDirectionsClick,
        caption: labels.getDirections,
        variant: "outline"
    }));
};

const StoreLocationContainer = (_param)=>{
    var { opco , code , name , town , country , streetName , streetNumber , additionalStreetInfo , postalCode , province , lat , lng , googleMapsApiKey  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "opco",
        "code",
        "name",
        "town",
        "country",
        "streetName",
        "streetNumber",
        "additionalStreetInfo",
        "postalCode",
        "province",
        "lat",
        "lng",
        "googleMapsApiKey"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.location.title'),
            getDirections: getLabel('stores.page.details.action.getDirections'),
            practicalInformationTitle: getLabel('stores.page.details.practicalInformation.title'),
            address: getLabel('stores.page.details.location.address')
        })
    , [
        getLabel
    ]);
    const addressData = React__default.useMemo(()=>({
            storeName: name,
            streetName,
            streetNumber,
            additionalStreetInfo,
            postalCode,
            town,
            province
        })
    , [
        name,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode,
        town,
        province
    ]);
    const mapImageUrl = React__default.useMemo(()=>`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=13&size=640x200&scale=2&markers=anchor:28,48|icon:https://assets.grandvision.io/global/store2.png|scale:2%7C${lat},${lng}&mapType=roadmap&key=${googleMapsApiKey}`
    , [
        lat,
        lng,
        googleMapsApiKey
    ]);
    const directionsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent([
        ...streetName.split(' '),
        town,
        opco
    ].join(' ').trim())}`;
    const onGetDirectionsClick = React__default.useCallback(()=>{
        const dataLayerEvent = storeDetailsEvent({
            interaction: 'get directions click',
            store: {
                code,
                name,
                town,
                country,
                streetName,
                streetNumber,
                additionalStreetInfo,
                postalCode
            }
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        code,
        name,
        town,
        country,
        streetName,
        streetNumber,
        additionalStreetInfo,
        postalCode
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreLocation, swcHelpers.extends({}, rest, {
        labels: labels,
        addressSize: "LARGE",
        addressData: addressData,
        mapImageUrl: mapImageUrl,
        directionsUrl: directionsUrl,
        onGetDirectionsClick: onGetDirectionsClick
    }));
};

const StoreBrands = (_param)=> {
    var { className , labels , brands  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "brands"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-brands-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-brands-stores-v2__list"
    }, brands.map(({ name  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-brands-stores-v2__list-item"
        }, name)
    )));
};

const StoreBrandContainer = ({ brands  })=>{
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.brands.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreBrands, {
        labels: labels,
        brands: brands
    });
};

const StorePaymentMethods = (_param)=> {
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-payment-methods-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-payment-methods-stores-v2__items"
    }, items.map(({ name , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: name,
            className: "store-payment-methods-stores-v2__item"
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-payment-methods-stores-v2__icon",
            alt: name,
            src: iconUrl
        }), name)
    )));
};

const StorePaymentMethodsContainer = (_param)=>{
    var { logos , paymentMethods  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "paymentMethods"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.paymentMethods.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return paymentMethods.map(({ code  })=>{
            var ref;
            const logo = logos === null || logos === void 0 ? void 0 : logos.find(({ key  })=>key === code
            );
            if (!logo) {
                return null;
            }
            return {
                name: logo.displayName,
                iconUrl: (ref = logo.logo) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        paymentMethods,
        logos
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StorePaymentMethods, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};

const StoreSocialMedia = (_param)=>{
    var { className , labels , items  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "items"
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-social-media-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h3"
    }, labels.title), /*#__PURE__*/ React__default.createElement("ul", {
        className: "store-social-media-stores-v2__list"
    }, items.map(({ name , url , iconUrl  })=>/*#__PURE__*/ React__default.createElement("li", {
            key: url,
            className: "store-social-media-stores-v2__list-item",
            "data-t": name
        }, /*#__PURE__*/ React__default.createElement("a", {
            href: url,
            target: "_blank",
            rel: "noreferrer",
            "aria-label": name
        }, /*#__PURE__*/ React__default.createElement("img", {
            className: "store-social-media-stores-v2__icon",
            src: iconUrl,
            alt: name
        })))
    )));
};

const StoreSocialMediaContainer = (_param)=>{
    var { logos =[] , socialMediaLinks =[]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "logos",
        "socialMediaLinks"
    ]);
    const { getLabel  } = useIntl();
    const labels = React__default.useMemo(()=>({
            title: getLabel('stores.page.details.socialMedia.title')
        })
    , [
        getLabel
    ]);
    const items = React__default.useMemo(()=>{
        return socialMediaLinks.map(({ code , url  })=>{
            var ref;
            const logo = logos.find(({ image  })=>{
                return (image === null || image === void 0 ? void 0 : image.description) === code;
            });
            if (!logo) {
                return null;
            }
            return {
                name: code,
                url,
                iconUrl: (ref = logo.image) === null || ref === void 0 ? void 0 : ref.url
            };
        }).filter((item)=>item !== null
        );
    }, [
        logos,
        socialMediaLinks
    ]);
    return items.length > 0 ? /*#__PURE__*/ React__default.createElement(StoreSocialMedia, swcHelpers.extends({}, rest, {
        labels: labels,
        items: items
    })) : null;
};

const openNowFilterFunction = (store)=>{
    const { openingHours , specialOpeningHours  } = store;
    return [
        'OPEN',
        'CLOSING'
    ].includes(getOpenCloseStatus(openingHours, specialOpeningHours));
};
const openOnSundayFilterFunction = (store)=>{
    const { openingHours  } = store;
    const Sunday = 0;
    return [
        'OPEN',
        'CLOSING'
    ].includes(getNormalOpenCloseStatusForDay(openingHours, Sunday));
};
const openOnTheWeekendFilterFunction = (store)=>store.weekendOpen === true
;
const wheelChairAccessibleFilterFunction = (store)=>store.wheelchairAccessible === true
;
const useDefaultStoreSearchFilters = (additionalFilters = {})=>{
    const { getLabel  } = useIntl();
    const storeSearchFilters = React.useMemo(()=>swcHelpers.objectSpread({
            openNow: {
                label: getLabel('stores.component.storeFinder.filter.openNow'),
                active: false,
                filterFunction: openNowFilterFunction,
                order: 0
            },
            openOnTheWeekend: {
                label: getLabel('stores.component.storeFinder.filter.openOnTheWeekend'),
                active: false,
                filterFunction: openOnTheWeekendFilterFunction,
                order: 1
            },
            openOnSunday: {
                label: getLabel('stores.component.storeFinder.filter.openOnSunday'),
                active: false,
                filterFunction: openOnSundayFilterFunction,
                order: 2
            },
            wheelChairAccessible: {
                label: getLabel('stores.component.storeFinder.filter.wheelChairAccessible'),
                active: false,
                filterFunction: wheelChairAccessibleFilterFunction,
                order: 3
            }
        }, additionalFilters)
    , [
        getLabel,
        additionalFilters
    ]);
    return storeSearchFilters;
};
const setLoadingState = (callback)=>{
    callback(true);
    setTimeout(()=>callback(false)
    , 100);
};
const emptyObject = {};
const useStoreSearchFilters = (props)=>{
    const [loading, setLoading] = React.useState(false);
    var _filters1;
    const [storeSearchFilters, setStoreSearchFilters] = React.useState((_filters1 = props.filters) !== null && _filters1 !== void 0 ? _filters1 : emptyObject);
    const storeSearchFilterList = React.useMemo(()=>{
        const entries = Object.entries(storeSearchFilters);
        var _order, _order1;
        return entries.sort(([, a], [, b])=>((_order = a.order) !== null && _order !== void 0 ? _order : entries.length) - ((_order1 = b.order) !== null && _order1 !== void 0 ? _order1 : entries.length)
        ) // Unordered filters come last
        ;
    }, [
        storeSearchFilters
    ]);
    const hasActiveFilters = React.useMemo(()=>storeSearchFilterList.some(([, filter])=>filter.active
        )
    , [
        storeSearchFilterList
    ]);
    const setFilterActivity = React.useCallback((storeFilterName, active)=>{
        setLoadingState(setLoading);
        const filter = storeSearchFilters[storeFilterName];
        setStoreSearchFilters(swcHelpers.objectSpread({}, storeSearchFilters, {
            [storeFilterName]: swcHelpers.objectSpread({}, filter, {
                active
            })
        }));
    }, [
        storeSearchFilters
    ]);
    const activeFilters = React.useMemo(()=>Object.keys(storeSearchFilters).filter((key)=>storeSearchFilters[key].active === true
        )
    , [
        storeSearchFilters
    ]);
    const clearAllFilters = React.useCallback(()=>{
        setLoadingState(setLoading);
        setStoreSearchFilters(Object.keys(storeSearchFilters).reduce((acc, key)=>{
            acc[key] = swcHelpers.objectSpread({}, storeSearchFilters[key], {
                active: false
            });
            return acc;
        }, swcHelpers.objectSpread({}, storeSearchFilters)));
    }, [
        storeSearchFilters
    ]);
    const applyActiveFilters = React.useCallback((storeSearchResults)=>{
        if (!hasActiveFilters) {
            return storeSearchResults;
        }
        return Object.values(storeSearchFilters).reduce((acc, filter)=>{
            if (!filter.active) {
                return acc;
            }
            return acc.filter(filter.filterFunction);
        }, storeSearchResults);
    }, [
        hasActiveFilters,
        storeSearchFilters
    ]);
    React.useEffect(()=>{
        var _filters;
        setStoreSearchFilters((_filters = props.filters) !== null && _filters !== void 0 ? _filters : emptyObject);
    }, [
        props.filters
    ]);
    return React.useMemo(()=>[
            {
                setFilterActivity,
                applyActiveFilters,
                clearAllFilters
            },
            {
                storeSearchFilters,
                storeSearchFilterList,
                hasActiveFilters,
                loading,
                activeFilters
            }, 
        ]
    , [
        setFilterActivity,
        applyActiveFilters,
        clearAllFilters,
        loading,
        storeSearchFilters,
        storeSearchFilterList,
        hasActiveFilters,
        activeFilters, 
    ]);
};

const StoreListItemContainer = ({ className , store: store1 , buttons , loading , onMouseEnter , onMouseLeave ,  })=>{
    const { config , stores  } = useStoreFinderContext();
    const { hidePhone , hideEmail  } = config;
    const { additionalStreetInfo , streetName , streetNumber , postalCode , town , province , country ,  } = store1;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province,
            country
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province,
        country
    ]);
    const onMouseEnterHandler = React__default.useCallback(()=>onMouseEnter && onMouseEnter(store1)
    , [
        store1,
        onMouseEnter, 
    ]);
    const onMouseLeaveHandler = React__default.useCallback(()=>onMouseLeave && onMouseLeave(store1)
    , [
        store1,
        onMouseLeave, 
    ]);
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onExpandOpeningHoursCallback = React__default.useCallback(()=>{
        onStoresLocatorResultEvent({
            store: store1,
            interaction: 'opening times click',
            searchPosition: stores.indexOf(store1) + 1
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        stores
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreListItem, {
        className: className,
        onExpandOpeningHoursCallback: onExpandOpeningHoursCallback,
        store: store1,
        addressData: addressData,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        buttons: buttons,
        loading: loading,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
    });
};

var StoreSearchFilterItemContainer = (_param)=>{
    var { className , filterKey , filter , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filterKey",
        "filter",
        "setFilterActivity"
    ]);
    const { getFormattedLabel  } = useIntl();
    const onClick = React.useCallback(()=>setFilterActivity(filterKey, !filter.active)
    , [
        filterKey,
        filter,
        setFilterActivity, 
    ]);
    return /*#__PURE__*/ React.createElement(QuickFilterButton, swcHelpers.extends({}, rest, {
        label: filter.label,
        ariaLabels: {
            active: getFormattedLabel(`stores.component.storeFinder.filter.active`, {
                labelData: {
                    filter: filter.label
                }
            }),
            inactive: getFormattedLabel(`stores.component.storeFinder.filter.inactive`, {
                labelData: {
                    filter: filter.label
                }
            })
        },
        active: filter.active,
        onClick: onClick
    }));
};

var StoreSearchFilters = (_param)=>{
    var { className , filters , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filters",
        "setFilterActivity"
    ]);
    return (filters === null || filters === void 0 ? void 0 : filters.length) ? /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('store-search-filters', className)
    }), filters.map(([filterKey, filter])=>/*#__PURE__*/ React.createElement("li", {
            key: filterKey.toString(),
            className: "store-search-filters__list-item"
        }, /*#__PURE__*/ React.createElement(StoreSearchFilterItemContainer, {
            filterKey: filterKey.toString(),
            filter: filter,
            setFilterActivity: setFilterActivity
        }))
    )) : null;
};

const placeById = gql`
  fragment PlaceById on Place {
    coordinates {
      lat
      lon
    }
  }
`;
const GET_PLACE_BY_ID = gql`
  query GetPlaceById($id: String!) {
    placeById(id: $id) {
      ...PlaceById
    }
  }
  ${placeById}
`;

const storesByDistance = gql`
  fragment StoresByDistance on Store {
    code
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    shortName
    email
    phone
    storenote
    servicesNotAvailable
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    wheelchairAccessible
    weekendOpen
  }
`;
const GET_STORES_BY_DISTANCE = gql`
  query GetStoresByDistance(
    $searchGeoLocation: GeoLocationInput!
    $deviceGeoLocation: GeoLocationInput
    $maxResults: Int
    $query: String
    $filter: StoreFilter
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      deviceGeoLocation: $deviceGeoLocation
      maxResults: $maxResults
      query: $query
      filter: $filter
    ) {
      ...StoresByDistance
    }
  }
  ${storesByDistance}
`;

const storeByCode = gql`
  fragment StoreByCode on Store {
    code
    streetName
    streetNumber
    name
    town
  }
`;
const GET_STORE_BY_CODE = gql`
  query GetStoreByCode($code: Int!) {
    store(code: $code) {
      ...StoreByCode
    }
  }
  ${storeByCode}
`;

const storeDetails = gql`
  fragment StoreDetails on Store {
    code
    globalStoreId
    slug
    streetName
    streetNumber
    additionalStreetInfo
    postalCode
    town
    province
    country
    lat
    lon
    name
    email
    storeDetailImage
    phone
    description
    storenote
    storeFacilities
    metaDescription
    servicesNotAvailable
    wheelchairAccessible
    practicalInformation
    hearingAppointmentPossible
    features {
      paymentMethods {
        code
      }
      socialMediaLinks {
        code
        url
      }
      availableBrands {
        name
      }
      productCategories {
        code
      }
    }
    monOpenClose {
      open
      close
    }
    tueOpenClose {
      open
      close
    }
    wedOpenClose {
      open
      close
    }
    thuOpenClose {
      open
      close
    }
    friOpenClose {
      open
      close
    }
    satOpenClose {
      open
      close
    }
    sunOpenClose {
      open
      close
    }
    specialOpenClosingHours {
      openClosed
      dateOpenClosed
      openClosedTime {
        open
        close
      }
    }
    offers {
      title
      description
      url
      imageUrl
    }
    rating {
      value
      count
    }
    breadcrumbName
    breadcrumbSlug
    googlePlaceId
    googlePlaceReviewUrl
  }
`;
const GET_STORE_DETAILS = gql`
  query GetStoreDetails($code: Int, $deviceGeoLocation: GeoLocationInput, $slug: String) {
    store(code: $code, deviceGeoLocation: $deviceGeoLocation, slug: $slug) {
      ...StoreDetails
    }
  }
  ${storeDetails}
`;

const nearestStore = gql`
  fragment NearestStore on Store {
    code
    slug
    town
    shortName
    storeDetailImage
    distance
    breadcrumbName
    breadcrumbSlug
  }
`;
const GET_NEAREST_STORES = gql`
  query GetNearestStores(
    $searchGeoLocation: GeoLocationInput!
    $maxResults: Int
    $maxDistance: Int
    $filter: StoreFilter
    $forceDistance: Boolean
  ) {
    storesByDistance(
      searchGeoLocation: $searchGeoLocation
      maxResults: $maxResults
      maxDistance: $maxDistance
      filter: $filter
      forceDistance: $forceDistance
    ) {
      ...NearestStore
    }
  }
  ${nearestStore}
`;

const fromStoresByDistanceQueryToStoresByDistance = (storeSearchQueryData)=>{
    if (!storeSearchQueryData) {
        return null;
    }
    try {
        return storeSearchQueryData.map((entry1)=>{
            const { code , slug , name , shortName , storenote , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , servicesNotAvailable , monOpenClose , tueOpenClose , wedOpenClose , thuOpenClose , friOpenClose , satOpenClose , sunOpenClose , specialOpenClosingHours , wheelchairAccessible , weekendOpen ,  } = entry1;
            return {
                code,
                name,
                shortName,
                streetName,
                town,
                country,
                phone,
                slug: slug !== null && slug !== void 0 ? slug : undefined,
                storeNote: storenote !== null && storenote !== void 0 ? storenote : undefined,
                streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
                additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
                postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
                province: province !== null && province !== void 0 ? province : undefined,
                lat: lat !== null && lat !== void 0 ? lat : undefined,
                lon: lon !== null && lon !== void 0 ? lon : undefined,
                emailAddress: email !== null && email !== void 0 ? email : undefined,
                servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : [],
                openingHours: {
                    monday: (monOpenClose !== null && monOpenClose !== void 0 ? monOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    tuesday: (tueOpenClose !== null && tueOpenClose !== void 0 ? tueOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    wednesday: (wedOpenClose !== null && wedOpenClose !== void 0 ? wedOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    thursday: (thuOpenClose !== null && thuOpenClose !== void 0 ? thuOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    friday: (friOpenClose !== null && friOpenClose !== void 0 ? friOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    saturday: (satOpenClose !== null && satOpenClose !== void 0 ? satOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    ),
                    sunday: (sunOpenClose !== null && sunOpenClose !== void 0 ? sunOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                    )
                },
                specialOpeningHours: (specialOpenClosingHours !== null && specialOpenClosingHours !== void 0 ? specialOpenClosingHours : []).filter((entry)=>entry !== null
                ),
                wheelchairAccessible: wheelchairAccessible !== null && wheelchairAccessible !== void 0 ? wheelchairAccessible : false,
                weekendOpen: weekendOpen !== null && weekendOpen !== void 0 ? weekendOpen : false
            };
        });
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeSearchQueryData);
        return null;
    }
};

const fromPlaceByIdQueryToPlaceById = (data)=>{
    if (!data) {
        return null;
    }
    const { coordinates: { lat , lon  } ,  } = data;
    return {
        coordinates: {
            lat,
            lon
        }
    };
};

const fromStoreByCodeQueryToStoreByCode = (storeQuery)=>{
    if (!storeQuery) {
        return null;
    }
    try {
        const { code , name , streetName , streetNumber , town  } = storeQuery;
        return {
            code,
            name,
            streetName,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            town
        };
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, storeQuery);
        return null;
    }
};

const fromStoreQueryDataToStoreDetails = (storeQueryData)=>{
    if (!storeQueryData) {
        return null;
    }
    try {
        const { code , globalStoreId , slug , name , description , storenote , email , storeDetailImage , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , lat , lon , phone , metaDescription , servicesNotAvailable , features , storeFacilities , monOpenClose , tueOpenClose , wedOpenClose , thuOpenClose , friOpenClose , satOpenClose , sunOpenClose , specialOpenClosingHours , offers , hearingAppointmentPossible , wheelchairAccessible , breadcrumbName , breadcrumbSlug , practicalInformation , rating , googlePlaceId , googlePlaceReviewUrl ,  } = storeQueryData;
        var ref, ref1, ref2, ref3;
        return {
            code,
            globalStoreId,
            name,
            streetName,
            town,
            country,
            phone,
            practicalInformation: practicalInformation !== null && practicalInformation !== void 0 ? practicalInformation : undefined,
            slug: slug !== null && slug !== void 0 ? slug : undefined,
            description: description !== null && description !== void 0 ? description : undefined,
            storeNote: storenote !== null && storenote !== void 0 ? storenote : undefined,
            detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
            streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
            additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
            postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
            province: province !== null && province !== void 0 ? province : undefined,
            wheelchairAccessible: wheelchairAccessible !== null && wheelchairAccessible !== void 0 ? wheelchairAccessible : undefined,
            hearingAppointmentPossible: hearingAppointmentPossible !== null && hearingAppointmentPossible !== void 0 ? hearingAppointmentPossible : undefined,
            lat: lat !== null && lat !== void 0 ? lat : undefined,
            lon: lon !== null && lon !== void 0 ? lon : undefined,
            emailAddress: email !== null && email !== void 0 ? email : undefined,
            metaDescription: metaDescription !== null && metaDescription !== void 0 ? metaDescription : undefined,
            servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : [],
            breadcrumbName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
            breadcrumbSlug: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined,
            brands: (ref = features === null || features === void 0 ? void 0 : features.availableBrands) !== null && ref !== void 0 ? ref : [],
            facilities: (storeFacilities !== null && storeFacilities !== void 0 ? storeFacilities : []).filter((entry)=>entry !== null
            ),
            openingHours: {
                monday: (monOpenClose !== null && monOpenClose !== void 0 ? monOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                tuesday: (tueOpenClose !== null && tueOpenClose !== void 0 ? tueOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                wednesday: (wedOpenClose !== null && wedOpenClose !== void 0 ? wedOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                thursday: (thuOpenClose !== null && thuOpenClose !== void 0 ? thuOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                friday: (friOpenClose !== null && friOpenClose !== void 0 ? friOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                saturday: (satOpenClose !== null && satOpenClose !== void 0 ? satOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                ),
                sunday: (sunOpenClose !== null && sunOpenClose !== void 0 ? sunOpenClose : []).filter((entry)=>entry !== null && entry.open !== null && entry.close !== null
                )
            },
            specialOpeningHours: (specialOpenClosingHours !== null && specialOpenClosingHours !== void 0 ? specialOpenClosingHours : []).filter((entry)=>entry !== null
            ),
            paymentMethods: (ref1 = features === null || features === void 0 ? void 0 : features.paymentMethods) !== null && ref1 !== void 0 ? ref1 : [],
            socialMediaLinks: (ref2 = features === null || features === void 0 ? void 0 : features.socialMediaLinks) !== null && ref2 !== void 0 ? ref2 : undefined,
            storeProductCategories: (ref3 = features === null || features === void 0 ? void 0 : features.productCategories) !== null && ref3 !== void 0 ? ref3 : [],
            offers,
            rating: rating ? {
                value: rating.value,
                count: rating.count
            } : undefined,
            googlePlaceId: googlePlaceId !== null && googlePlaceId !== void 0 ? googlePlaceId : undefined,
            googlePlaceReviewUrl: googlePlaceReviewUrl !== null && googlePlaceReviewUrl !== void 0 ? googlePlaceReviewUrl : undefined
        };
    } catch (e) {
        console.error('Store query data adapter failed to parse input data correctly.', e, storeQueryData);
        return null;
    }
};

const fromNearestStoresQueryToNearestStores = (nearestStoresQueryData)=>{
    if (!nearestStoresQueryData) {
        return null;
    }
    try {
        return nearestStoresQueryData.map((entry)=>{
            const { code , slug , town , shortName , storeDetailImage , distance , breadcrumbName , breadcrumbSlug ,  } = entry;
            const isDistanceInMeters = (value)=>typeof value === 'number'
            ;
            return {
                code,
                town,
                shortName,
                distance: isDistanceInMeters(distance) ? distance : undefined,
                slug: slug !== null && slug !== void 0 ? slug : undefined,
                detailImage: storeDetailImage !== null && storeDetailImage !== void 0 ? storeDetailImage : undefined,
                groupName: breadcrumbName !== null && breadcrumbName !== void 0 ? breadcrumbName : undefined,
                groupPath: breadcrumbSlug !== null && breadcrumbSlug !== void 0 ? breadcrumbSlug : undefined
            };
        });
    } catch (e) {
        console.error('Store search query data adapter failed to parse input data correctly.', e, nearestStoresQueryData);
        return null;
    }
};

const usePlaceById = (variables)=>{
    const [query, queryState] = useLazyQuery(GET_PLACE_BY_ID, {
        variables,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getPlaceById.error');
            console.error('Failed to fetch place by id: ', error);
        }
    });
    return React__default.useMemo(()=>{
        var ref;
        return [
            query,
            swcHelpers.objectSpread({}, queryState, {
                data: fromPlaceByIdQueryToPlaceById((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.placeById)
            }), 
        ];
    }, [
        query,
        queryState
    ]);
};

const useStoreByCode = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_BY_CODE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        onError (error) {
            toast.failed('stores.page.search.getStoreByCode.error');
            console.error('Failed to fetch store by code: ', error);
        }
    });
    var _data;
    const { store  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromStoreByCodeQueryToStoreByCode(store)
    , [
        store
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoreDetails = ()=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_DETAILS, {
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        fetchPolicy: 'no-cache'
    });
    const data = React.useMemo(()=>{
        var ref;
        const storeQueryData = (ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store;
        return fromStoreQueryDataToStoreDetails(storeQueryData);
    }, [
        queryState.data
    ]);
    const getStoreDetails = React.useCallback((slugOrCode)=>{
        query({
            variables: {
                [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
            }
        });
    }, [
        query
    ]);
    React.useEffect(()=>{
        if (queryState.error) {
            console.error('Failed to fetch store details: ', queryState.error);
        }
    }, [
        queryState.error
    ]);
    return React.useMemo(()=>[
            getStoreDetails,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        getStoreDetails,
        queryState,
        data, 
    ]);
};

const useStoresByDistance = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORES_BY_DISTANCE, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            toast.failed('stores.page.search.getStoresByDistance.error');
            console.error('Failed to fetch store by distance: ', error);
        }
    });
    var _data;
    const { storesByDistance  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromStoresByDistanceQueryToStoresByDistance(storesByDistance)
    , [
        storesByDistance, 
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

const useStoreFinderUrlParams = ({ handleOnChange , setIsUserLocation , newQueryParams , enabled =false  })=>{
    const [initialSearchQuery, setInitialSearchQuery] = React__default.useState(undefined);
    React__default.useEffect(()=>{
        if (!enabled) {
            return;
        }
        const search = Util$1.getQueryParamByKey('search');
        const isUserLocation = Util$1.getQueryParamByKey('userLocation') === 'true';
        setIsUserLocation(isUserLocation);
        setInitialSearchQuery(search);
        if ((search === null || search === void 0 ? void 0 : search.length) && !isUserLocation) {
            handleOnChange(search);
        }
    }, []);
    React__default.useEffect(()=>{
        if (enabled) {
            replaceStoreFinderUrlWithNewQueryParams(newQueryParams);
        }
    }, [
        enabled,
        newQueryParams
    ]);
    return initialSearchQuery;
};

const MyCurrentLocation = (_param)=> {
    var { label , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('my-current-location-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Icon, {
        name: "gps"
    }), /*#__PURE__*/ React__default.createElement("span", {
        className: "my-current-location-stores-v2__label"
    }, label));
};

const StoreSearchForm = (_param)=>{
    var { className , labels , loading , showClearButton , searchQuery , suggestions , searchRef , onChange , onSubmit , onClear , onSuggestionClick , onUseMyCurrentLocation , isFocusedOnMount , isSuggestionSelected , isUsingUserLocation , minSearchCharacterCount , onSuggestionTopContentClick , queryResultsFilters  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "loading",
        "showClearButton",
        "searchQuery",
        "suggestions",
        "searchRef",
        "onChange",
        "onSubmit",
        "onClear",
        "onSuggestionClick",
        "onUseMyCurrentLocation",
        "isFocusedOnMount",
        "isSuggestionSelected",
        "isUsingUserLocation",
        "minSearchCharacterCount",
        "onSuggestionTopContentClick",
        "queryResultsFilters"
    ]);
    const autoCompleteLabels = React__default.useMemo(()=>({
            placeholder: labels.placeholder,
            noResults: labels.noResults,
            noAvailableResultsScreenReaderHint: labels.noAvailableResultsScreenReaderHint
        })
    , [
        labels
    ]);
    return /*#__PURE__*/ React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-search-field-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-search-field-stores-v2__search-form"
    }, /*#__PURE__*/ React__default.createElement("form", {
        role: "search",
        action: "",
        onSubmit: (event)=>{
            console.log('Submit was prevented');
            event && event.preventDefault();
            onSubmit();
        }
    }, /*#__PURE__*/ React__default.createElement(Autocomplete, {
        className: classnames({
            'store-search-field-stores-v2__search-form--with-user--location': isUsingUserLocation
        }),
        inputRef: searchRef,
        name: "store-search",
        type: "search",
        labels: autoCompleteLabels,
        isFocusedOnMount: isFocusedOnMount,
        loading: loading,
        value: searchQuery,
        showClearButton: showClearButton,
        submitIcon: /*#__PURE__*/ React__default.createElement(Icon, {
            name: "search"
        }),
        minCountCharactersToSubmit: minSearchCharacterCount,
        isSuggestionSelected: isSuggestionSelected,
        suggestionTopContent: !isUsingUserLocation ? /*#__PURE__*/ React__default.createElement(MyCurrentLocation, {
            label: labels.useMyCurrentLocation
        }) : undefined,
        suggestions: suggestions,
        inputDataT: "search",
        onChange: onChange,
        onSubmit: onSubmit,
        onClear: onClear,
        onSuggestionClick: onSuggestionClick,
        onSuggestionTopContentClick: onSuggestionTopContentClick,
        disabled: isUsingUserLocation
    })), !isUsingUserLocation && /*#__PURE__*/ React__default.createElement(Button, {
        variant: "outline",
        icon: "gps",
        caption: labels.useMyCurrentLocation,
        className: "store-search-field-stores-v2__button",
        onClick: onUseMyCurrentLocation,
        "data-t": "userLocationBtn"
    })), queryResultsFilters ? /*#__PURE__*/ React__default.createElement("div", {
        className: "store-search-field-stores-v2__query-results-filters"
    }, queryResultsFilters) : null);
};

const scrollToFormHandlerId = 'location-search-form';
const MIN_SEARCH_CHARACTER_COUNT = 2;
const StoreSearchFormContainer = (_param)=>{
    var { appointmentTypeId , minSearchCharacterCount =MIN_SEARCH_CHARACTER_COUNT , storeQueryFilter , queryResultsFilters  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "appointmentTypeId",
        "minSearchCharacterCount",
        "storeQueryFilter",
        "queryResultsFilters"
    ]);
    const { getLabel  } = useIntl();
    const { config , searchQuery , isPristineSearch , suggestions , isLocationSelected , userLocation , isUsingUserLocation , isUserLocationLoading , useUserLocationError , setIsUserLocationRequested , clearSearch , setSelectedLocation , setSuggestions , setIsPristineSearch , setStores , setSearchQuery , setIsStoresLoading ,  } = useStoreFinderContext();
    const searchRef = /*#__PURE__*/ React__default.createRef();
    const { featureConfigs  } = useFeatureToggles();
    const maxSearchStoresResults = (featureConfigs === null || featureConfigs === void 0 ? void 0 : featureConfigs.maxSearchStoresResults) !== undefined ? featureConfigs.maxSearchStoresResults : 30;
    const { withUrlParams , storeFilter  } = config;
    const isMobile = MediaQuery.useBreakpoint() === MediaQuery.BreakpointName.PHONE;
    const [isWaitingForSuggestions, setIsWaitingForSuggestions] = React__default.useState(false);
    const [getPlacePredictions, placePredictions] = usePlacePredictions({
        variables: {
            name: searchQuery
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError: (error)=>{
            toast.failed('stores.page.search.getPlacePredictions.error');
            console.error('Failed to fetch place predictions: ', error);
        }
    });
    const [getPlaceById, placeById] = usePlaceById({
        id: ''
    });
    const [getStoresByDistance, storesByDistance] = useStoresByDistance({
        searchGeoLocation: {
            lat: '',
            lon: ''
        },
        filter: storeQueryFilter
    });
    const [userLocationInSessionStorage, setUserLocationInSessionStorage, ] = useSessionStorage('grandvision_user_location', undefined, (value)=>value === undefined
    );
    const labels = React__default.useMemo(()=>({
            placeholder: getLabel('stores.page.search.searchForm.placeholder'),
            noResults: getLabel('stores.page.autocomplete.noResults'),
            useMyCurrentLocation: getLabel('stores.page.search.useMyCurrentLocation'),
            myCurrentLocationPlaceholder: getLabel('stores.page.search.useMyCurrentLocation.placeholder'),
            noAvailableResultsScreenReaderHint: getLabel('elements.autocomplete.noAvailableResultsScreenReaderHint')
        })
    , [
        getLabel
    ]);
    const onStoreSearchSubmitEvent = React__default.useCallback(({ location , interaction  })=>{
        var ref;
        const dataLayerEvent = storeSearchSubmitEvent({
            interaction,
            location,
            searchResults: ((ref = storesByDistance.data) === null || ref === void 0 ? void 0 : ref.length) || null
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, [
        storesByDistance.data
    ]);
    const handleOnChange = React__default.useCallback((value)=>{
        setSearchQuery(value);
        setIsWaitingForSuggestions(false);
        // In case selected location and value in the search field are the same,
        // nothing changed in the input and we can keep selected location
        setSelectedLocation((prevLocation)=>prevLocation === value ? prevLocation : ''
        );
    }, [
        setSearchQuery,
        setSelectedLocation
    ]);
    /** Hook to build store finder URL based on search state,
   *  to handle initial page state on first page load based on query parameters in URL
   */ const newQueryParams = React__default.useMemo(()=>isUsingUserLocation ? {
            userLocation: 'true'
        } : {
            search: searchQuery
        }
    , [
        isUsingUserLocation,
        searchQuery
    ]);
    const initialSearchQuery = useStoreFinderUrlParams({
        handleOnChange,
        setIsUserLocation: setIsUserLocationRequested,
        newQueryParams,
        enabled: withUrlParams
    });
    const getStoresByLocation = React__default.useCallback((id)=>{
        getPlaceById({
            variables: {
                id
            }
        });
        setIsStoresLoading(true);
        const address = getAddressFromSuggestions(suggestions, id);
        setSelectedLocation(address);
        withUrlParams && replaceStoreFinderUrlWithNewQueryParams({
            search: address
        });
        setSuggestions([]);
        if (isPristineSearch) {
            setIsPristineSearch(false);
        }
    }, [
        getPlaceById,
        setSelectedLocation,
        setSuggestions,
        setIsStoresLoading,
        isPristineSearch,
        suggestions,
        setIsPristineSearch,
        withUrlParams, 
    ]);
    const onSuggestionClick = React__default.useCallback((id)=>{
        getStoresByLocation(id);
    }, [
        getStoresByLocation
    ]);
    const onChange = React__default.useCallback((event)=>handleOnChange(event.currentTarget.value)
    , [
        handleOnChange
    ]);
    const onSubmit = React__default.useCallback(()=>{
        if (suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
        } else {
            setIsWaitingForSuggestions(true);
        }
    }, [
        getStoresByLocation,
        setIsWaitingForSuggestions,
        suggestions
    ]);
    React__default.useEffect(()=>{
        if (isUsingUserLocation) {
            setSearchQuery(labels.myCurrentLocationPlaceholder);
            setSelectedLocation(labels.myCurrentLocationPlaceholder);
        }
    }, [
        isUsingUserLocation,
        labels.myCurrentLocationPlaceholder,
        setSearchQuery,
        setSelectedLocation, 
    ]);
    const handleOnSearch = React__default.useCallback(()=>{
        if (searchQuery.length >= minSearchCharacterCount && !isLocationSelected && !isUsingUserLocation) {
            getPlacePredictions({
                variables: {
                    name: searchQuery
                }
            });
        }
    }, [
        searchQuery,
        minSearchCharacterCount,
        isLocationSelected,
        isUsingUserLocation,
        getPlacePredictions, 
    ]);
    const onUseMyCurrentLocation = React__default.useCallback(()=>{
        setIsUserLocationRequested(true);
        setIsWaitingForSuggestions(false);
    }, [
        setIsUserLocationRequested,
        setIsWaitingForSuggestions
    ]);
    useDebouncedEffect(()=>{
        handleOnSearch();
    }, 500, [
        searchQuery
    ]);
    React__default.useEffect(()=>{
        if (!placePredictions.data) {
            return;
        }
        setSuggestions(mapPlacePredictionToSuggestion(placePredictions.data));
    }, [
        placePredictions.data
    ]);
    React__default.useEffect(()=>{
        if (storesByDistance.error || placeById.error) {
            setIsStoresLoading(false);
        }
    }, [
        storesByDistance.error,
        placeById.error,
        setIsStoresLoading
    ]);
    React__default.useEffect(()=>{
        if (useUserLocationError) {
            setSearchQuery('');
            setSelectedLocation('');
            setIsUserLocationRequested(false);
            onStoreSearchSubmitEvent({
                location: null,
                interaction: 'current location'
            });
        }
    }, [
        useUserLocationError,
        setSearchQuery,
        setSelectedLocation,
        setIsUserLocationRequested
    ]);
    React__default.useEffect(()=>{
        if (!placeById.data) {
            return;
        }
        const { coordinates: { lat , lon  } ,  } = placeById.data;
        const deviceGeoLocation = userLocation ? {
            lat: userLocation.lat,
            lon: userLocation.lng
        } : userLocationInSessionStorage && Object.keys(userLocationInSessionStorage).length !== 0 ? {
            lat: userLocationInSessionStorage.lat,
            lon: userLocationInSessionStorage.lng
        } : undefined;
        getStoresByDistance({
            variables: {
                query: appointmentTypeId,
                maxResults: maxSearchStoresResults,
                searchGeoLocation: {
                    lat,
                    lon
                },
                deviceGeoLocation,
                filter: storeQueryFilter
            }
        });
    // Effect should only run on chaning placeById.data or appointmentTypeId
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        placeById.data,
        appointmentTypeId
    ]);
    React__default.useEffect(()=>{
        var ref;
        if (!storesByDistance.data) {
            return;
        }
        onStoreSearchSubmitEvent({
            location: storesByDistance.data[0].town,
            interaction: isUsingUserLocation && userLocation !== undefined ? 'current location' : 'location typed'
        });
        setStores(storesByDistance.data.filter(storeFilter));
        setIsStoresLoading(false);
        (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.blur();
        if (isMobile && storesByDistance.data.length > 0) {
            var // Can't use ref in this case because we have two search forms on the page.
            // During the first search ref in useEffect points to the old search field
            // So we need to get needed search form by id.
            // Alternative way ref.current?.scrollIntoView(), but it doesn't work for the first search.
            ref1;
            (ref1 = document.getElementById(scrollToFormHandlerId)) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        storesByDistance.data
    ]);
    React__default.useEffect(()=>{
        if (searchQuery.length < minSearchCharacterCount) {
            setSuggestions([]);
        }
    }, [
        searchQuery,
        minSearchCharacterCount,
        setSuggestions
    ]);
    React__default.useEffect(()=>{
        if (!userLocation) {
            return;
        }
        if (isPristineSearch) {
            setIsPristineSearch(false);
        }
        setUserLocationInSessionStorage(userLocation);
        const { lat , lng: lon  } = userLocation;
        getStoresByDistance({
            variables: {
                query: appointmentTypeId,
                maxResults: maxSearchStoresResults,
                searchGeoLocation: {
                    lat,
                    lon
                },
                deviceGeoLocation: {
                    lat,
                    lon
                }
            }
        });
        setIsStoresLoading(true);
    }, [
        userLocation,
        appointmentTypeId,
        isPristineSearch
    ]);
    /** Should select first suggestion if already waiting for suggestions list */ React__default.useEffect(()=>{
        if (isWaitingForSuggestions && suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
            setIsWaitingForSuggestions(false);
        }
    }, [
        suggestions,
        isWaitingForSuggestions,
        getStoresByLocation,
        setIsWaitingForSuggestions
    ]);
    React__default.useEffect(()=>{
        if (initialSearchQuery === searchQuery && isPristineSearch && suggestions.length > 0) {
            getStoresByLocation(suggestions[0].id);
        }
    }, [
        initialSearchQuery,
        searchQuery,
        isPristineSearch,
        suggestions,
        getStoresByLocation
    ]);
    // Dispatch keyup event on Enter and Space manually after pressing key on Use my location from the dropdown.
    // After pressing Use my location from the dropdown input becomes disabled,
    // when input disabled key events don't trigger on it.
    // Need to reset the keypress state to handle cursor correctly.
    React__default.useEffect(()=>{
        var ref, ref2;
        if (!isUsingUserLocation) {
            return;
        }
        (ref = searchRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new KeyboardEvent('keyup', {
            code: 'Enter'
        }));
        (ref2 = searchRef.current) === null || ref2 === void 0 ? void 0 : ref2.dispatchEvent(new KeyboardEvent('keyup', {
            code: 'Space'
        }));
    }, [
        isUsingUserLocation,
        searchRef
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreSearchForm, swcHelpers.extends({}, rest, {
        searchRef: searchRef,
        labels: labels,
        loading: placePredictions.loading || isUserLocationLoading,
        showClearButton: searchQuery.length > 0,
        searchQuery: searchQuery,
        suggestions: suggestions,
        onChange: onChange,
        onSubmit: onSubmit,
        onClear: clearSearch,
        onSuggestionClick: onSuggestionClick,
        onSuggestionTopContentClick: onUseMyCurrentLocation,
        onUseMyCurrentLocation: onUseMyCurrentLocation,
        isSuggestionSelected: isLocationSelected,
        isFocusedOnMount: true,
        isUsingUserLocation: isUsingUserLocation,
        minSearchCharacterCount: minSearchCharacterCount,
        queryResultsFilters: queryResultsFilters
    }));
};

const StoreFinderContainer = ({ isInsideModal , listTopContent , listInfoContent , listItemComponent , infoWindowContentComponent , buttonsComponent , storeSearchFilters: propStoreSearchFilters ,  })=>{
    const { getFormattedLabel , getLabel  } = useIntl();
    const { isPristineSearch , isStoresLoading , stores , config , setHoveredStore ,  } = useStoreFinderContext();
    const [{ setFilterActivity , applyActiveFilters , clearAllFilters  }, { storeSearchFilters , storeSearchFilterList , hasActiveFilters , loading , activeFilters  }, ] = useStoreSearchFilters({
        filters: propStoreSearchFilters
    });
    const { googleMapsId  } = config;
    const prevActiveFilters = React__default.useRef([]);
    const showListTopContent = Boolean(listTopContent);
    const showListInfoContent = Boolean(listInfoContent);
    // Passing an explicit null for listTopContent, will result in a fallback to null
    const listTopContentFallback = !showListTopContent ? /*#__PURE__*/ React__default.createElement(StoreListTopContent, {
        title: getLabel('stores.page.search.title', {
            hideLabelKey: true
        }),
        description: getFormattedLabel('stores.page.search.description', {
            hideLabelKey: true,
            parseLink: true
        })
    }) : null;
    const ButtonsComponent = buttonsComponent;
    const onMouseEnterHandler = React__default.useCallback((store)=>setHoveredStore(store)
    , [
        setHoveredStore, 
    ]);
    const onMouseLeaveHandler = React__default.useCallback(()=>setHoveredStore(null)
    , [
        setHoveredStore
    ]);
    const ListItemComponent = listItemComponent !== null && listItemComponent !== void 0 ? listItemComponent : StoreListItemContainer;
    const filteredStores = React__default.useMemo(()=>applyActiveFilters(stores)
    , [
        stores,
        applyActiveFilters, 
    ]);
    useEffect(()=>{
        if (prevActiveFilters.current.length !== activeFilters.length) {
            prevActiveFilters.current = activeFilters;
            const dataLayerEvent = storesSearchFilterEvent({
                activeFilters,
                searchResults: filteredStores.length
            });
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        activeFilters
    ]);
    return /*#__PURE__*/ React__default.createElement(LocationSearch, {
        className: classnames('store-finder-stores-v2', {
            'store-finder-stores-v2--modal': isInsideModal
        }),
        googleMapsId: googleMapsId,
        isPristineSearch: isPristineSearch,
        searchForm: /*#__PURE__*/ React__default.createElement(StoreSearchFormContainer, {
            queryResultsFilters: (stores === null || stores === void 0 ? void 0 : stores.length) ? /*#__PURE__*/ React__default.createElement(StoreSearchFilters, {
                filters: storeSearchFilterList,
                setFilterActivity: setFilterActivity
            }) : null
        }),
        listTopContent: showListTopContent ? listTopContent : listTopContentFallback,
        listInfoContent: hasActiveFilters && filteredStores.length === 0 && /*#__PURE__*/ React__default.createElement(Alert, {
            type: "warning",
            icon: "warning"
        }, getLabel('stores.page.search.filters.warning'), /*#__PURE__*/ React__default.createElement(Button$1, {
            className: "store-finder-stores-v2__clear-filters-action",
            variant: "ghost",
            onClick: clearAllFilters
        }, getLabel('stores.page.search.filters.clearButton'))) || (showListInfoContent ? listInfoContent : null),
        loadingListItems: isStoresLoading,
        listItems: filteredStores.map((store)=>/*#__PURE__*/ React__default.createElement(ListItemComponent, {
                loading: loading,
                key: store.code,
                store: store,
                buttons: ButtonsComponent ? /*#__PURE__*/ React__default.createElement(ButtonsComponent, {
                    store: store,
                    view: "list"
                }) : undefined,
                onMouseEnter: onMouseEnterHandler,
                onMouseLeave: onMouseLeaveHandler
            })
        ),
        mapContent: /*#__PURE__*/ React__default.createElement(StoreFinderMapContainer, {
            stores: filteredStores,
            infoWindowContentComponent: infoWindowContentComponent,
            buttonsComponent: ButtonsComponent
        })
    });
};

const StoreOffersContainer = (props)=>{
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.offers.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, props, {
        labels: labels
    }));
};

const StoreCategoriesContainer = (_param)=>{
    var { storeCategories , fallbackImage  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeCategories",
        "fallbackImage"
    ]);
    const { getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getLabel('stores.page.details.productGroups.title')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(ProductOffers, swcHelpers.extends({}, rest, {
        offers: storeCategories,
        fallbackImage: fallbackImage,
        labels: labels
    }));
};

var StoreRatingContainer = (_param)=>{
    var { store  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store"
    ]);
    const { getLabel , getFormattedLabel  } = useIntl();
    const { isStoreRatingsEnabled  } = useFeatureToggles();
    var ref4, ref1;
    const labels = React.useMemo(()=>{
        var ref3, ref2;
        return {
            title: getLabel('stores.component.storeRating.title'),
            rating: getFormattedLabel('stores.component.storeRating.rating', {
                labelData: {
                    rating: (ref4 = (ref3 = store.rating) === null || ref3 === void 0 ? void 0 : ref3.value) !== null && ref4 !== void 0 ? ref4 : ''
                }
            }),
            ratingCount: getFormattedLabel('stores.component.storeRating.ratingCount', {
                labelData: {
                    count: (ref1 = (ref2 = store.rating) === null || ref2 === void 0 ? void 0 : ref2.count) !== null && ref1 !== void 0 ? ref1 : ''
                }
            }),
            description: getLabel('stores.component.storeRating.description'),
            review: getLabel('stores.component.storeRating.review')
        };
    }, [
        getLabel,
        getFormattedLabel,
        store
    ]);
    const urls = React.useMemo(()=>{
        var ref;
        return {
            review: ((ref = store.googlePlaceReviewUrl) === null || ref === void 0 ? void 0 : ref.length) ? store.googlePlaceReviewUrl : undefined
        };
    }, [
        store
    ]);
    const onClickReview = React.useCallback(()=>{
        // TODO: Implement data layer event
        console.log(store);
    }, [
        store
    ]);
    if (!isStoreRatingsEnabled || !store.rating) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(StoreRating, swcHelpers.extends({}, rest, {
        labels: labels,
        rating: store.rating.value,
        urls: urls,
        onClickReview: onClickReview
    }));
};

var ServicesNotAvailable;
(function(ServicesNotAvailable) {
    ServicesNotAvailable["APPOINTMENTS"] = "APPOINTMENTS";
    ServicesNotAvailable["CLICK_AND_RESERVE"] = "CLICK_AND_RESERVE";
    ServicesNotAvailable["EVENING_APPOINTMENTS"] = "EVENING_APPOINTMENTS";
    ServicesNotAvailable["OPTOMETRY"] = "OPTOMETRY";
    ServicesNotAvailable["PICK_UP_IN_STORE"] = "PICK_UP_IN_STORE";
})(ServicesNotAvailable || (ServicesNotAvailable = {}));

const OPENING_HOURS_DAYS = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday', 
];
var OpenClosedStatus;
(function(OpenClosedStatus) {
    OpenClosedStatus["Open"] = 'OPEN';
    OpenClosedStatus["Closing"] = 'CLOSING';
    OpenClosedStatus["Closed"] = 'CLOSED';
})(OpenClosedStatus || (OpenClosedStatus = {}));

var types$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get ServicesNotAvailable () { return ServicesNotAvailable; },
  OPENING_HOURS_DAYS: OPENING_HOURS_DAYS,
  get OpenClosedStatus () { return OpenClosedStatus; }
});

const DefaultButtonsContainer = ({ store: store1 , view , storeDetailsUrlProvider , bookAppointmentUrlProvider ,  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const storeDetailsUrl = storeDetailsUrlProvider(store1);
    const bookAppointmentUrl = bookAppointmentUrlProvider(store1);
    const showBookAppointmentCTA = areServicesAvailable(store1, [
        ServicesNotAvailable.APPOINTMENTS
    ]);
    const { code  } = store1;
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onBookAppointmentButtonClickHandler = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'book appointment click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - book appointment',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores
    ]);
    const onStoreDetailButtonClickHandler = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'store details click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - store details',
            searchResults: stores.length
        });
    }, [
        onStoresLocatorResultEvent,
        store1,
        view,
        stores
    ]);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showBookAppointmentCTA ? /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onBookAppointmentButtonClickHandler,
        href: bookAppointmentUrl,
        variant: "solid",
        size: "small",
        "data-t": `book-appointment-${code}`,
        caption: getLabel('stores.page.storeGroup.action.bookAppointment')
    }) : null, /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onStoreDetailButtonClickHandler,
        href: storeDetailsUrl,
        variant: "outline",
        size: "small",
        "data-t": `store-details-${code}`,
        caption: getLabel('stores.page.storeGroup.action.storeDetails')
    }));
};
function withDefaultButtonsConfig(buttonsComponent, config) {
    const ButtonsComponent = buttonsComponent;
    const WithDefaultButtonsConfig = (props)=>{
        const { featureConfigs: { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } ,  } = useFeatureToggles();
        const { urls  } = config;
        if (!urls.storeDetails) {
            console.error(`Missing url for storeDetails within withDefaultButtonsConfig`);
        }
        const storeDetailsUrlProvider = getStoreDetailUrl(urls.storeDetails || '');
        if (!urls.bookAppointment) {
            console.error(`Missing url for bookAppointment within withDefaultButtonsConfig`);
        }
        const bookAppointmentUrlProvider = getBookAppointmentUrl(urls.bookAppointment || '', {
            paddedLength: appointmentBookingUrlPaddedLength,
            alternativeUrl: appointmentBookingAlternativeUrl,
            alternativeUrlStores: appointmentBookingAlternativeUrlStores
        });
        return /*#__PURE__*/ React__default.createElement(ButtonsComponent, swcHelpers.extends({}, props, {
            storeDetailsUrlProvider: storeDetailsUrlProvider,
            bookAppointmentUrlProvider: bookAppointmentUrlProvider
        }));
    };
    WithDefaultButtonsConfig.displayName = `WithDefaultButtonsConfig${getDisplayName(ButtonsComponent)}`;
    return WithDefaultButtonsConfig;
}

const PickUpButtonsContainer = ({ store: store1 , view , onStoreSelect  })=>{
    const { getLabel  } = useIntl();
    const { stores  } = useStoreFinderContext();
    const onStoresLocatorResultEvent = React__default.useCallback(({ store , interaction , searchPosition , searchResults  })=>{
        const dataLayerEvent = storesLocatorResultEvent({
            interaction,
            store,
            searchPosition,
            searchResults
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    const onClick = React__default.useCallback(()=>{
        onStoresLocatorResultEvent(view === 'list' ? {
            store: store1,
            interaction: 'select store click',
            searchPosition: stores.indexOf(store1) + 1
        } : {
            store: store1,
            interaction: 'map click - select store',
            searchResults: stores.length
        });
        onStoreSelect(store1);
    }, [
        onStoresLocatorResultEvent,
        onStoreSelect,
        store1,
        view,
        stores
    ]);
    return /*#__PURE__*/ React__default.createElement(Button, {
        onClick: onClick,
        variant: "outline",
        size: "small",
        "data-t": `select-pick-up-store-${store1.code}`,
        caption: getLabel('checkout.storeFinder.action')
    });
};
function withPickUpButtonsConfig(buttonsComponent, config) {
    const ButtonsComponent = buttonsComponent;
    const WithPickUpButtonsConfig = (props)=>{
        const { onStoreSelect  } = config;
        return /*#__PURE__*/ React__default.createElement(ButtonsComponent, swcHelpers.extends({}, props, {
            onStoreSelect: onStoreSelect
        }));
    };
    WithPickUpButtonsConfig.displayName = `WithPickUpButtonsConfig${getDisplayName(ButtonsComponent)}`;
    return WithPickUpButtonsConfig;
}

const NearbyStores = ({ id ='nearby-stores' , className , labels , stores , links ,  })=>/*#__PURE__*/ React.createElement("section", {
        id: id,
        className: classnames('nearby-stores', className),
        "aria-labelledby": `${id}-title`
    }, /*#__PURE__*/ React.createElement(Heading, {
        id: `${id}-title`,
        variant: "smallest",
        component: "h2"
    }, labels.title), /*#__PURE__*/ React.createElement("div", {
        className: "nearby-stores__group"
    }, stores.map(({ code , url , image , label , distance  })=>/*#__PURE__*/ React.createElement("a", {
            className: "nearby-stores__group-item",
            key: code,
            href: url
        }, /*#__PURE__*/ React.createElement("img", {
            className: "nearby-stores__group-item-thumbnail",
            loading: "lazy",
            src: image,
            alt: label
        }), /*#__PURE__*/ React.createElement(Text, {
            className: "nearby-stores__group-item-label",
            variant: "body-head"
        }, label), /*#__PURE__*/ React.createElement(Text, {
            className: "nearby-stores__group-item-distance",
            variant: "body"
        }, distance))
    )), /*#__PURE__*/ React.createElement("div", {
        className: "nearby-stores__links"
    }, links.map(({ label , url  })=>/*#__PURE__*/ React.createElement("a", {
            key: url,
            href: url
        }, label)
    )))
;

var NearbyStoresContainer = (_param)=>{
    var { stores: storeData , urls , storeDetails  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "stores",
        "urls",
        "storeDetails"
    ]);
    const { getLabel , distanceUnit , getFormattedLabel  } = useIntl();
    const storeDetailsUrlProvider = React.useMemo(()=>{
        return getStoreDetailUrl((urls === null || urls === void 0 ? void 0 : urls.storeDetails) || '');
    }, [
        urls, 
    ]);
    const labels = React.useMemo(()=>({
            title: getLabel('stores.component.nearbyStores.title')
        })
    , [
        getLabel
    ]);
    const stores = React.useMemo(()=>{
        return storeData.filter((store)=>{
            return !(storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.code) || (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.code) !== store.code;
        }).map((store)=>{
            const storeDetailsUrl = storeDetailsUrlProvider(store);
            const distance = store.distance !== undefined ? formatDistance(store.distance, distanceUnit, {
                separator: ' '
            }) : store.distance;
            var _detailImage, ref;
            return {
                code: store.code,
                url: storeDetailsUrl,
                image: (ref = (_detailImage = store.detailImage) !== null && _detailImage !== void 0 ? _detailImage : urls === null || urls === void 0 ? void 0 : urls.fallbackImage) !== null && ref !== void 0 ? ref : '',
                label: store.shortName,
                distance: getFormattedLabel('stores.component.nearbyStores.distance', {
                    labelData: {
                        distance: distance !== null && distance !== void 0 ? distance : ''
                    }
                })
            };
        });
    }, [
        storeData,
        urls,
        distanceUnit,
        storeDetailsUrlProvider,
        getFormattedLabel,
        storeDetails
    ]);
    const links = React.useMemo(()=>{
        const linksToBeAdded = [];
        if ((storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbName) && (storeDetails === null || storeDetails === void 0 ? void 0 : storeDetails.breadcrumbSlug)) {
            linksToBeAdded.push({
                label: getFormattedLabel('stores.component.nearbyStores.group', {
                    labelData: {
                        groupName: storeDetails.breadcrumbName
                    }
                }),
                url: storeDetails.breadcrumbSlug
            });
        }
        if (urls === null || urls === void 0 ? void 0 : urls.storeOverview) {
            linksToBeAdded.push({
                label: getLabel('stores.component.nearbyStores.allStores'),
                url: urls.storeOverview
            });
        }
        return linksToBeAdded;
    }, [
        urls,
        getLabel,
        getFormattedLabel,
        storeDetails
    ]);
    return /*#__PURE__*/ React.createElement(NearbyStores, swcHelpers.extends({}, rest, {
        labels: labels,
        stores: stores,
        links: links
    }));
};

var containers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  StoreContactInfo: StoreContactInfoContainer,
  StoreBookAppointmentCTA: StoreBookAppointmentCTAContainer,
  StoreFacilities: StoreFacilitiesContainer,
  StoreFinderMap: StoreFinderMapContainer,
  StoreDetailImage: StoreDetailImageContainer,
  StoreDescription: StoreDescriptionContainer,
  StoreDistance: StoreDistance,
  StoreLocation: StoreLocationContainer,
  StoreBrands: StoreBrandContainer,
  StorePaymentMethods: StorePaymentMethodsContainer,
  StoreSocialMedia: StoreSocialMediaContainer,
  StoreFinder: StoreFinderContainer,
  StoreSearchForm: StoreSearchFormContainer,
  StoreListItem: StoreListItemContainer,
  StoreOffers: StoreOffersContainer,
  StoreCategories: StoreCategoriesContainer,
  StoreRating: StoreRatingContainer,
  DefaultButtons: DefaultButtonsContainer,
  withDefaultButtonsConfig: withDefaultButtonsConfig,
  PickUpButtons: PickUpButtonsContainer,
  withPickUpButtonsConfig: withPickUpButtonsConfig,
  NearbyStores: NearbyStoresContainer
});

var types = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Actions: actions,
  Types: types
});

const useIsInViewport = (currentElement)=>{
    if (typeof window === 'undefined') return false;
    const [isInViewport, setIsInViewport] = React.useState(false);
    const checkIsInViewport = ()=>{
        if (!currentElement.current) {
            setIsInViewport(false);
            return;
        }
        const { top , height: refHeight  } = currentElement.current.getBoundingClientRect();
        setIsInViewport(top + refHeight >= 0 && top <= window.innerHeight);
    };
    React.useEffect(()=>{
        checkIsInViewport();
        const throttledCheckIsInViewport = throttle(200, false, ()=>{
            checkIsInViewport();
        });
        window.addEventListener('scroll', throttledCheckIsInViewport);
        return ()=>window.removeEventListener('scroll', throttledCheckIsInViewport)
        ;
    }, []);
    return isInViewport;
};

var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useIsInViewport: useIsInViewport,
  useDefaultStoreSearchFilters: useDefaultStoreSearchFilters,
  useStoreSearchFilters: useStoreSearchFilters,
  usePlaceById: usePlaceById,
  useStoreByCode: useStoreByCode,
  useStoreDetails: useStoreDetails,
  useStoresByDistance: useStoresByDistance
});

function getPageData$1(apolloClient, slugOrCode, locale) {
    return _getPageData$1.apply(this, arguments);
}
function _getPageData$1() {
    _getPageData$1 = swcHelpers.asyncToGenerator(function*(apolloClient, slugOrCode, locale, withNearestStores = false, maxDistance) {
        try {
            var ref;
            const storeQuery = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_DETAILS,
                variables: {
                    [typeof slugOrCode === 'string' ? 'slug' : 'code']: slugOrCode
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeQueryData = (ref = storeQuery.data) === null || ref === void 0 ? void 0 : ref.store;
            const storeData = fromStoreQueryDataToStoreDetails(storeQueryData);
            if (storeQuery.error) {
                console.error(storeQuery.error);
            }
            const nearestStores = [];
            if (withNearestStores && (storeData === null || storeData === void 0 ? void 0 : storeData.lat) !== undefined && (storeData === null || storeData === void 0 ? void 0 : storeData.lon) !== undefined) {
                var ref1;
                const nearestStoresQuery = yield apolloClient.query({
                    query: GET_NEAREST_STORES,
                    variables: {
                        searchGeoLocation: {
                            lat: storeData === null || storeData === void 0 ? void 0 : storeData.lat,
                            lon: storeData === null || storeData === void 0 ? void 0 : storeData.lon
                        },
                        forceDistance: true,
                        maxResults: 2,
                        maxDistance,
                        filter: {
                            excludeGlobalStoreId: `${storeData === null || storeData === void 0 ? void 0 : storeData.globalStoreId}`
                        }
                    }
                });
                const nearestStoresQueryData = (ref1 = nearestStoresQuery.data) === null || ref1 === void 0 ? void 0 : ref1.storesByDistance;
                var ref2;
                nearestStores.push(...(ref2 = fromNearestStoresQueryToNearestStores(nearestStoresQueryData)) !== null && ref2 !== void 0 ? ref2 : []);
                if (nearestStoresQuery.error) {
                    console.error(nearestStoresQuery.error);
                }
            }
            return {
                storeData,
                nearestStores
            };
        } catch (e) {
            console.error(e);
            return {
                storeData: null,
                nearestStores: []
            };
        }
    });
    return _getPageData$1.apply(this, arguments);
}

var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPageData: getPageData$1
});

const fromListStoreGroupsQueryToStoreGroup = (data)=>{
    if (!data) {
        return {};
    }
    const sortedStores = [
        ...data.multiStoreGroups,
        ...data.singleStoreGroups
    ].sort((a, b)=>a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    );
    const storeGroups = sortedStores.reduce((acc, value)=>{
        const firstNameStoreLetter = value.name.toUpperCase()[0];
        const existingStore = acc[firstNameStoreLetter];
        const groupedExistingStores = existingStore && [
            ...existingStore,
            value
        ];
        return swcHelpers.objectSpread({}, acc, {
            [firstNameStoreLetter]: groupedExistingStores ? groupedExistingStores : [
                value
            ]
        });
    }, {});
    return storeGroups;
};

const listStoreGroups = gql`
  fragment ListStoreGroups on StoreGroups {
    singleStoreGroups {
      name
      store {
        slug
        town
      }
    }
    multiStoreGroups {
      name
      slug
    }
  }
`;
const GET_LIST_STORE_GROUPS = gql`
  query GetListStoreGroups {
    listStoreGroups {
      ...ListStoreGroups
    }
  }
  ${listStoreGroups}
`;

function getListStoreGroups(apolloClient, locale) {
    return _getListStoreGroups.apply(this, arguments);
}
function _getListStoreGroups() {
    _getListStoreGroups = swcHelpers.asyncToGenerator(function*(apolloClient, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_LIST_STORE_GROUPS
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            if (error) {
                console.error(error);
                throw new Error(error.message);
            }
            return fromListStoreGroupsQueryToStoreGroup(data === null || data === void 0 ? void 0 : data.listStoreGroups);
        } catch (e) {
            console.error(`Failed to query listStoreGroups: ${e}`);
            return {};
        }
    });
    return _getListStoreGroups.apply(this, arguments);
}

var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  fromListStoreGroupsQueryToStoreGroup: fromListStoreGroupsQueryToStoreGroup,
  getListStoreGroups: getListStoreGroups,
  GET_LIST_STORE_GROUPS: GET_LIST_STORE_GROUPS
});

const fromStoreGroupQueryDataToStores = (storeGroupQueryData)=>{
    if (!storeGroupQueryData) {
        return [];
    }
    try {
        return storeGroupQueryData.map((entry)=>{
            const { code , slug , name , email , streetName , streetNumber , additionalStreetInfo , postalCode , town , province , country , phone , servicesNotAvailable ,  } = entry;
            return {
                code,
                name,
                streetName,
                town,
                country,
                phone,
                slug: slug !== null && slug !== void 0 ? slug : undefined,
                streetNumber: streetNumber !== null && streetNumber !== void 0 ? streetNumber : undefined,
                additionalStreetInfo: additionalStreetInfo !== null && additionalStreetInfo !== void 0 ? additionalStreetInfo : undefined,
                postalCode: postalCode !== null && postalCode !== void 0 ? postalCode : undefined,
                province: province !== null && province !== void 0 ? province : undefined,
                emailAddress: email !== null && email !== void 0 ? email : undefined,
                servicesNotAvailable: servicesNotAvailable !== null && servicesNotAvailable !== void 0 ? servicesNotAvailable : []
            };
        });
    } catch (e) {
        console.error('Store group query data adapter failed to parse input data correctly.', e, storeGroupQueryData);
        return [];
    }
};

const storeGroupEntry = gql`
  fragment StoreGroupEntry on Store {
    code
    name
    streetName
    streetNumber
    additionalStreetInfo
    town
    province
    country
    slug
    postalCode
    storeEmailAddress
    email
    phone
    servicesNotAvailable
  }
`;
const GET_STORE_GROUP = gql`
  query GetStoreGroup($groupName: String!) {
    stores(groupName: $groupName) {
      ...StoreGroupEntry
    }
  }
  ${storeGroupEntry}
`;

function getPageData(apolloClient, groupName, locale) {
    return _getPageData.apply(this, arguments);
}
function _getPageData() {
    _getPageData = swcHelpers.asyncToGenerator(function*(apolloClient, groupName, locale) {
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_STORE_GROUP,
                variables: {
                    groupName
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const storeGroupQueryData = data.stores;
            const storeGroupData = fromStoreGroupQueryDataToStores(storeGroupQueryData);
            if (error) {
                console.error(error);
            }
            return {
                storeGroupData
            };
        } catch (e) {
            console.error(e);
            return {
                storeGroupData: []
            };
        }
    });
    return _getPageData.apply(this, arguments);
}

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  getPageData: getPageData
});

const StoreDetailsRoot = ({ store , opco , hidePhone , hideEmail , googleMapsApiKey , breadcrumbs , urls , appointmentTypeId , logos , dropInAppointmentBookingWidget: DropInWidget = null , nearestStores =[] , campaignBanner , productCategories ,  })=>{
    var ref;
    const { getFormattedLabel  } = useIntl();
    const canShowBookAppointmentWidget = areServicesAvailable(store, [
        ServicesNotAvailable.APPOINTMENTS
    ]) && Boolean((ref = urls.bookAppointment) === null || ref === void 0 ? void 0 : ref.length);
    const showBookAppointmentDropInWidget = canShowBookAppointmentWidget && Boolean(appointmentTypeId === null || appointmentTypeId === void 0 ? void 0 : appointmentTypeId.length) && DropInWidget;
    const showBookAppointmentCTA = canShowBookAppointmentWidget && !showBookAppointmentDropInWidget;
    const { name , description , detailImage , emailAddress , phone , streetName , streetNumber , postalCode , town , province , country , code , additionalStreetInfo , lat , lon , storeNote , openingHours , specialOpeningHours , facilities , brands , paymentMethods , socialMediaLinks , offers , wheelchairAccessible , storeProductCategories , hearingAppointmentPossible ,  } = store;
    const bookAppointmentButtonRef = React__default.useRef(null);
    const dropInWidgetRef = React__default.useRef(null);
    const isBookAppointmentButtonInViewport = useIsInViewport(bookAppointmentButtonRef);
    const isDropInWidgetInViewport = useIsInViewport(dropInWidgetRef);
    const storeCategories = getActiveStoreOffers(productCategories, storeProductCategories);
    const activeCampaignBanner = getActiveCampaignBanner(campaignBanner, {
        storeCode: code
    });
    const { featureConfigs: { storeDistanceConfig  } = {}  } = useFeatureToggles();
    const hideStickyBookAppointmentButton = isBookAppointmentButtonInViewport || isDropInWidgetInViewport;
    const showPaymentMethods = !!paymentMethods && !!(logos === null || logos === void 0 ? void 0 : logos.paymentMethods) && paymentMethods.length > 0 && logos.paymentMethods.length > 0;
    const showSocialMedia = !!socialMediaLinks && !!(logos === null || logos === void 0 ? void 0 : logos.socialMedia) && socialMediaLinks.length > 0 && logos.socialMedia.length > 0;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province
    ]);
    const distanceDetails = React__default.useMemo(()=>storeDistanceConfig ? /*#__PURE__*/ React__default.createElement(StoreDistance, {
            code: code
        }) : null
    , [
        code,
        storeDistanceConfig
    ]);
    const labels = React__default.useMemo(()=>{
        const label = getFormattedLabel('stores.storeDetailsRoot.announcement', {
            hideLabelKey: true,
            parseLink: true
        });
        if (!label) {
            return {};
        }
        return {
            storeAnnouncement: label
        };
    }, [
        getFormattedLabel
    ]);
    var _bookAppointment, _bookAppointment1;
    return /*#__PURE__*/ React__default.createElement("article", {
        className: "store-details-stores-v2"
    }, breadcrumbs && /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__breadcrumbs"
    }, /*#__PURE__*/ React__default.createElement(Breadcrumbs, {
        pages: breadcrumbs
    })), breadcrumbs.length >= 2 && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__breadcrumb"
    }, /*#__PURE__*/ React__default.createElement(SimpleBreadcrumb, {
        title: breadcrumbs[1].name,
        href: breadcrumbs[1].url
    }))), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__content-wrapper"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__main-content-wrapper"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__main-content"
    }, /*#__PURE__*/ React__default.createElement(StoreDetailImageContainer, {
        className: "store-details-stores-v2__detail-image",
        detailImage: detailImage,
        fallbackImage: urls.fallbackImage
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__contact-info"
    }, /*#__PURE__*/ React__default.createElement(Location, {
        id: code,
        name: name,
        variant: Types.LocationVariant.StandAlone,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        locationDetailsUrl: '',
        headerImage: activeCampaignBanner,
        highlight: false,
        addressData: addressData,
        addressSize: "COMPLETE",
        wheelchairAccessible: wheelchairAccessible,
        hearingAppointmentPossible: hearingAppointmentPossible,
        distanceDetails: distanceDetails,
        openingHours: /*#__PURE__*/ React__default.createElement(OpeningHours, {
            withTitle: true,
            announcement: storeNote,
            openingHours: openingHours,
            specialOpeningHours: specialOpeningHours,
            isExpandable: false,
            isExpanded: true
        }),
        buttons: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showBookAppointmentDropInWidget ? /*#__PURE__*/ React__default.createElement("div", {
            className: "store-details-stores-v2__drop-in-widget-container",
            ref: dropInWidgetRef
        }, /*#__PURE__*/ React__default.createElement(DropInWidget, {
            urls: urls,
            storeId: code,
            typeId: appointmentTypeId,
            dataLayerEvents: {
                storeAppointmentClickEvent: 'storeDetailsFastAppointmentClick',
                storeChangeAppointmentTypeClickEvent: 'storeDetailsChangeClick'
            }
        })) : null, showBookAppointmentCTA ? /*#__PURE__*/ React__default.createElement("div", {
            ref: bookAppointmentButtonRef,
            className: "store-details-stores-v2__book-appointment"
        }, /*#__PURE__*/ React__default.createElement(StoreBookAppointmentCTAContainer, {
            url: (_bookAppointment = urls.bookAppointment) !== null && _bookAppointment !== void 0 ? _bookAppointment : '',
            code: code,
            name: name,
            town: town,
            country: country,
            streetName: streetName,
            streetNumber: streetNumber,
            additionalStreetInfo: additionalStreetInfo,
            postalCode: postalCode,
            appointmentTypeId: appointmentTypeId,
            storeCode: store.code
        })) : null, labels.storeAnnouncement && /*#__PURE__*/ React__default.createElement(Text, {
            variant: "caption",
            children: labels.storeAnnouncement
        }))
    }))), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__secondary-content"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__location"
    }, /*#__PURE__*/ React__default.createElement(StoreLocationContainer, {
        opco: opco,
        code: code,
        name: name,
        town: town,
        province: province,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        lat: lat,
        lng: lon,
        googleMapsApiKey: googleMapsApiKey,
        distanceDetails: distanceDetails,
        practicalInformation: store.practicalInformation
    })), facilities && facilities.length > 0 && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__facilities"
    }, /*#__PURE__*/ React__default.createElement(StoreFacilitiesContainer, {
        facilities: facilities
    })), /*#__PURE__*/ React__default.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React__default.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React__default.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React__default.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__description"
    }, /*#__PURE__*/ React__default.createElement(StoreDescriptionContainer, {
        storeName: name,
        description: description
    })), brands && brands.length > 0 && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__brands"
    }, /*#__PURE__*/ React__default.createElement(StoreBrandContainer, {
        brands: brands
    })), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__payment-methods-social-media"
    }, showPaymentMethods && !!logos && /*#__PURE__*/ React__default.createElement(StorePaymentMethodsContainer, {
        className: "store-details-stores-v2__payment-methods",
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && !!logos && /*#__PURE__*/ React__default.createElement(StoreSocialMediaContainer, {
        className: "store-details-stores-v2__social-media",
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    })))), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__side-content"
    }, /*#__PURE__*/ React__default.createElement("div", {
        className: "store-details-stores-v2__detail-image"
    }, /*#__PURE__*/ React__default.createElement(StoreDetailImageContainer, {
        detailImage: detailImage,
        fallbackImage: urls.fallbackImage
    })), /*#__PURE__*/ React__default.createElement(StoreRatingContainer, {
        store: store
    }), offers && offers.length > 0 && /*#__PURE__*/ React__default.createElement(StoreOffersContainer, {
        className: "store-details-stores-v2__store-offers",
        fallbackImage: urls.offerFallbackImage,
        offers: offers
    }), nearestStores.length > 0 && /*#__PURE__*/ React__default.createElement(NearbyStoresContainer, {
        className: "store-details-stores-v2__nearest-stores",
        stores: nearestStores,
        urls: urls,
        storeDetails: store
    }), storeCategories && storeCategories.length > 0 && /*#__PURE__*/ React__default.createElement(StoreCategoriesContainer, {
        className: "store-details-stores-v2__store-product-groups",
        fallbackImage: urls.productCategoryFallbackImage,
        storeCategories: storeCategories
    }), showPaymentMethods && logos && /*#__PURE__*/ React__default.createElement(StorePaymentMethodsContainer, {
        logos: logos.paymentMethods,
        paymentMethods: paymentMethods
    }), showSocialMedia && logos && /*#__PURE__*/ React__default.createElement(StoreSocialMediaContainer, {
        logos: logos.socialMedia,
        socialMediaLinks: socialMediaLinks
    }))), showBookAppointmentCTA && /*#__PURE__*/ React__default.createElement("div", {
        "data-t": "cta-sticky-footer",
        className: classnames('store-details-stores-v2__sticky-footer', {
            'store-details-stores-v2__sticky-footer--hidden': hideStickyBookAppointmentButton
        })
    }, /*#__PURE__*/ React__default.createElement(StoreBookAppointmentCTAContainer, {
        url: (_bookAppointment1 = urls.bookAppointment) !== null && _bookAppointment1 !== void 0 ? _bookAppointment1 : '',
        code: code,
        name: name,
        town: town,
        country: country,
        streetName: streetName,
        streetNumber: streetNumber,
        additionalStreetInfo: additionalStreetInfo,
        postalCode: postalCode,
        appointmentTypeId: appointmentTypeId,
        storeCode: store.code
    })));
};

const StoresOverviewRoot = (_param)=>{
    var { storeGroups , storeLocatorURL , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeGroups",
        "storeLocatorURL",
        "className"
    ]);
    const onClick = React__default.useCallback((city)=>{
        const dataLayerEvent = storeGroupEvent({
            interaction: 'city click',
            step: 'store group overview',
            city
        });
        DataLayer.pushEvent(dataLayerEvent);
    }, []);
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, !!storeGroups && Object.keys(storeGroups).length > 0 ? /*#__PURE__*/ React__default.createElement("article", swcHelpers.extends({}, rest, {
        className: classnames('store-overview-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement("div", {
        className: "store-overview-stores-v2__store-groups"
    }, Object.keys(storeGroups).map((groupName, index)=>{
        var ref;
         return React__default.createElement("div", {
            key: index,
            className: "store-overview-stores-v2__store-groups-item"
        }, /*#__PURE__*/ React__default.createElement("div", {
            className: "store-overview-stores-v2__store-groups-item-name-container"
        }, /*#__PURE__*/ React__default.createElement("p", {
            className: "store-overview-stores-v2__store-groups-item-name"
        }, groupName), /*#__PURE__*/ React__default.createElement(Hr, null)), (ref = storeGroups[groupName]) === null || ref === void 0 ? void 0 : ref.map((storeGroup)=>{
            const path = storeGroup.store ? `${storeLocatorURL}/${slugify(storeGroup.store.town)}/${storeGroup.store.slug || ''}` : `${storeLocatorURL}/${storeGroup.slug || ''}`;
            return /*#__PURE__*/ React__default.createElement("div", {
                key: storeGroup.name,
                className: "store-overview-stores-v2__store-groups-item-link-container"
            }, /*#__PURE__*/ React__default.createElement(Link, {
                onClick: ()=>onClick(storeGroup.name)
                ,
                url: path
            }, storeGroup.name));
        }));
    }))) : null);
};

const StoreGroupItem = (_param)=> {
    var { className , store: { code , name , phone , emailAddress  } , addressData , hidePhone , hideEmail , buttons  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "store",
        "addressData",
        "hidePhone",
        "hideEmail",
        "buttons"
    ]);
    return React__default.createElement(Location, swcHelpers.extends({}, rest, {
        className: classnames('store-group-item-stores-v2', className),
        key: code,
        id: code,
        name: name,
        variant: Types.LocationVariant.ListItem,
        emailAddress: emailAddress,
        phone: phone,
        emailHidden: hideEmail,
        phoneHidden: hidePhone,
        highlight: false,
        addressData: addressData,
        addressSize: addressData ? 'COMPLETE' : undefined,
        openingHours: null,
        buttons: buttons
    }));
};

const StoreGroupItemContainer = ({ store , urls , hidePhone , hideEmail  })=>{
    const { getLabel  } = useIntl();
    const { featureConfigs: { appointmentBookingUrlPaddedLength , appointmentBookingAlternativeUrl , appointmentBookingAlternativeUrlStores ,  } ,  } = useFeatureToggles();
    const showBookAppointmentCTA = areServicesAvailable(store, [
        ServicesNotAvailable.APPOINTMENTS
    ]);
    const storeDetailsUrl = getStoreDetailUrl(urls.storeDetails || '')(store);
    const bookAppointmentUrl = getBookAppointmentUrl(urls.bookAppointment || '', {
        paddedLength: appointmentBookingUrlPaddedLength,
        alternativeUrl: appointmentBookingAlternativeUrl,
        alternativeUrlStores: appointmentBookingAlternativeUrlStores
    })(store);
    const { code , name , additionalStreetInfo , streetName , streetNumber , postalCode , town , province , country ,  } = store;
    const addressData = React__default.useMemo(()=>({
            additionalStreetInfo,
            streetName,
            streetNumber,
            postalCode,
            town,
            province,
            country
        })
    , [
        additionalStreetInfo,
        streetName,
        streetNumber,
        postalCode,
        town,
        province,
        country
    ]);
    const onClickStoreDetails = React__default.useCallback(()=>{
        const dataLayerEvent = storeGroupEvent({
            interaction: 'store details click',
            step: 'store group',
            store: swcHelpers.objectSpread({
                code,
                name
            }, addressData)
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
    }, [
        code,
        name,
        addressData
    ]);
    const onClickBookAppointment = React__default.useCallback(()=>{
        const dataLayerEvent = storeGroupEvent({
            interaction: 'book appointment click',
            step: 'store group',
            store: swcHelpers.objectSpread({
                code,
                name
            }, addressData)
        });
        if (dataLayerEvent) {
            DataLayer.pushEvent(dataLayerEvent);
        }
        window.location.assign(bookAppointmentUrl);
    }, [
        bookAppointmentUrl,
        code,
        name,
        addressData
    ]);
    const buttons = React__default.useMemo(()=>/*#__PURE__*/ React__default.createElement(React__default.Fragment, null, showBookAppointmentCTA ? /*#__PURE__*/ React__default.createElement(Button, {
            onClick: onClickBookAppointment,
            variant: "solid",
            "data-t": `book-appointment-${code}`,
            caption: getLabel('stores.page.storeGroup.action.bookAppointment')
        }) : null, /*#__PURE__*/ React__default.createElement(Button, {
            href: storeDetailsUrl,
            onClick: onClickStoreDetails,
            variant: "outline",
            "data-t": `store-details-${code}`,
            caption: getLabel('stores.page.storeGroup.action.storeDetails')
        }))
    , [
        getLabel,
        code,
        storeDetailsUrl,
        showBookAppointmentCTA,
        onClickStoreDetails,
        onClickBookAppointment, 
    ]);
    return /*#__PURE__*/ React__default.createElement(StoreGroupItem, {
        store: store,
        addressData: addressData,
        hidePhone: hidePhone,
        hideEmail: hideEmail,
        buttons: buttons
    });
};

const StoreGroupRoot = ({ className , urls , stores , hideEmail , hidePhone  })=>{
    return /*#__PURE__*/ React__default.createElement("div", {
        className: classnames('store-group-stores-v2', className)
    }, stores.map((store)=>{
        return /*#__PURE__*/ React__default.createElement(StoreGroupItemContainer, {
            key: store.code,
            urls: urls,
            store: store,
            hidePhone: hidePhone,
            hideEmail: hideEmail
        });
    }));
};

const StoresRoot = ({ urls , googleMapsId , hidePhone , hideEmail , storeSearchFilters ,  })=>/*#__PURE__*/ React__default.createElement(StoreFinderProvider, {
        googleMapsId: googleMapsId,
        withUrlParams: true,
        hidePhone: hidePhone,
        hideEmail: hideEmail
    }, /*#__PURE__*/ React__default.createElement("style", {
        jsx: true,
        global: true
    }, `
      .banner,
      .notification-bar {
        position: relative;
        z-index: 100;
      }
    `), /*#__PURE__*/ React__default.createElement(StoreFinderContainer, {
        buttonsComponent: withDefaultButtonsConfig(DefaultButtonsContainer, {
            urls
        }),
        storeSearchFilters: storeSearchFilters
    }))
;

export { components as Components, containers as Containers, index$4 as DataLayer, index$2 as DetailsPage, index as GroupPage, index$3 as Hooks, StoreDetailsRoot, StoreFinderConsumer, StoreFinderProvider, StoreGroupRoot, index$1 as StoresOverviewPage, StoresOverviewRoot, StoresRoot, types$1 as Types, index$5 as Util, useStoreFinderContext };
//# sourceMappingURL=index.js.map
